(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9033],{

/***/ 40294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AttachmentButtons_AttachmentButtons; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./koba/components/Typography/index.ts + 6 modules
var Typography = __webpack_require__(63579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/filestack-js/build/browser/filestack.esm.js
var filestack_esm = __webpack_require__(34944);
;// CONCATENATED MODULE: ./koba/components/SimpleFilePicker/SimpleFilePicker.js










var SimpleFilePicker = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SimpleFilePicker, Component);
    var _super = (0,_create_super/* default */.Z)(SimpleFilePicker);
    function SimpleFilePicker(props) {
        (0,_class_call_check/* default */.Z)(this, SimpleFilePicker);
        var _this;
        _this = _super.call(this, props);
        // eslint-disable-next-line react/state-in-constructor
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "state", {
            isUploading: false,
            totalPercent: 0
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "openPicker", function() {
            _this.fileInput.click();
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onProgress", function(event) {
            _this.setState({
                totalPercent: event.totalPercent
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleFileChange", function(event) {
            var _props = _this.props, accept = _props.accept, awsRegion = _props.awsRegion, clientOptions = _props.clientOptions, maxFileSizeInMb = _props.maxFileSizeInMb, s3Path = _props.s3Path, s3Bucket = _props.s3Bucket, onError = _props.onError, onSuccess = _props.onSuccess, onUploading = _props.onUploading;
            var maxFileSizeInBytes = maxFileSizeInMb * 1024 * 1024;
            var uploadOptions = {
                onProgress: _this.onProgress
            };
            var storageOptions = {
                access: "public",
                container: s3Bucket,
                location: "s3",
                path: s3Path,
                region: awsRegion
            };
            var file = event.target.files[0];
            if (file.size > maxFileSizeInBytes) {
                return onError("File is too large. Maximum file size is ".concat(maxFileSizeInMb, "MB."));
            }
            // This will turn the accept prop into a regular expression, e.g.
            // "*/*" becomes ".*/.*"
            // "image/*" becomes "image/.*"
            // "image/png,image/jpeg,application/*" becomes "image/png|image/jpeg|application/.*"
            var fileTypeRegex = accept.replace(/,/g, "|").replace("*", ".*");
            if (!file.type.match(fileTypeRegex)) {
                return onError("File type ".concat(file.type, " is not accepted. Must be one of the following: ").concat(accept.replace(/,/g, ", ")));
            }
            _this.setState({
                isUploading: true
            }, function() {
                onUploading();
            });
            return _this.filestackClient.upload(file, uploadOptions, storageOptions, null, clientOptions).then(function(uploadedFile) {
                return onSuccess(uploadedFile);
            }).catch(function(failedFile) {
                _this.setState({
                    isUploading: false
                });
                return onError("Failed to upload ".concat(failedFile.name, "."));
            });
        });
        _this.filestackClient = filestack_esm.init(props.filestackAPIKey);
        return _this;
    }
    (0,_create_class/* default */.Z)(SimpleFilePicker, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _state = this.state, isUploading = _state.isUploading, totalPercent = _state.totalPercent;
                var _props = this.props, accept = _props.accept, render1 = _props.render, ariaControls = _props.ariaControls;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            accept: accept,
                            "aria-controls": ariaControls,
                            "data-qa": "simple-file-picker__input",
                            ref: function(ref) {
                                _this.fileInput = ref;
                            },
                            style: {
                                display: "none"
                            },
                            type: "file",
                            onChange: this.handleFileChange
                        }),
                        render1({
                            openPicker: this.openPicker,
                            isUploading: isUploading,
                            totalPercent: totalPercent
                        })
                    ]
                });
            }
        }
    ]);
    return SimpleFilePicker;
}(react.Component);
SimpleFilePicker.propTypes = {
    /** File types to accept, e.g. "image/*" */ accept: (prop_types_default()).string,
    ariaControls: (prop_types_default()).string,
    awsRegion: (prop_types_default()).string.isRequired,
    clientOptions: (prop_types_default()).object.isRequired,
    filestackAPIKey: (prop_types_default()).string.isRequired,
    maxFileSizeInMb: (prop_types_default()).number,
    /** Render prop used to render the upload button, will be passed an
   *  openPicker function, isUploading & totalPercent */ render: (prop_types_default()).func.isRequired,
    s3Bucket: (prop_types_default()).string.isRequired,
    s3Path: (prop_types_default()).string.isRequired,
    /** Function called when a file failed to be uploaded, will be passed an errorMessage string */ onError: (prop_types_default()).func,
    /** Function called when a file has successfully been uploaded, will be passed
   *  an uploadedFile object */ onSuccess: (prop_types_default()).func.isRequired,
    onUploading: (prop_types_default()).func
};
SimpleFilePicker.defaultProps = {
    accept: "*/*",
    ariaControls: null,
    maxFileSizeInMb: 5,
    onError: function() {},
    onUploading: function() {}
};
/* harmony default export */ var SimpleFilePicker_SimpleFilePicker = (SimpleFilePicker);

;// CONCATENATED MODULE: ./koba/components/SimpleFilePicker/index.js


// EXTERNAL MODULE: ./koba/components/CircularSpinner/index.ts + 1 modules
var CircularSpinner = __webpack_require__(71939);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(4067);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./components/AttachmentFileInput/AttachmentFileInput.module.scss
var AttachmentFileInput_module = __webpack_require__(94917);
var AttachmentFileInput_module_default = /*#__PURE__*/__webpack_require__.n(AttachmentFileInput_module);
// EXTERNAL MODULE: ./components/FileSizeLabel.tsx
var FileSizeLabel = __webpack_require__(68274);
;// CONCATENATED MODULE: ./components/AttachmentFileInput/FilePreview.tsx








var cx = bind_default().bind((AttachmentFileInput_module_default()));
var FilePreview = function(param) {
    var fileName = param.fileName, fileSizeInBytes = param.fileSizeInBytes, onRemove = param.onRemove, t = param.t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "aria-live": "polite",
        className: cx("file-container"),
        id: "file-attachment-preview",
        role: "region",
        title: t("File Preview"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography.P, {
                className: cx("file-container__name"),
                children: [
                    fileName,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Caption */.Y, {
                        children: [
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FileSizeLabel/* FileSizeLabel */.C, {
                                byteCount: fileSizeInBytes,
                                t: t
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                appearance: "knockout",
                ariaLabel: t("Remove attachment"),
                className: cx("remove-file-button"),
                size: "x-small",
                onClick: onRemove,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    name: "x-dismiss"
                })
            })
        ]
    });
};
/* harmony default export */ var AttachmentFileInput_FilePreview = (FilePreview);

;// CONCATENATED MODULE: ./components/AttachmentFileInput/ImagePreview.tsx






var ImagePreview_cx = bind_default().bind((AttachmentFileInput_module_default()));
var ImagePreview = function(param) {
    var imageName = param.imageName, imageUrl = param.imageUrl, onRemove = param.onRemove, t = param.t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: ImagePreview_cx("file-input__image-container"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            "aria-live": "polite",
            className: ImagePreview_cx("file-input__image-preview"),
            id: "file-attachment-preview",
            role: "region",
            title: t("Image Preview"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    alt: "Preview of ".concat(imageName),
                    className: ImagePreview_cx("file-input__image"),
                    src: imageUrl
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                    appearance: "default",
                    ariaLabel: t("Remove attachment"),
                    className: ImagePreview_cx("remove-image-button"),
                    onClick: onRemove,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        name: "x-dismiss"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var AttachmentFileInput_ImagePreview = (ImagePreview);

// EXTERNAL MODULE: ./components/AttachmentFileInput/AttachmentAltTextInput.tsx
var AttachmentAltTextInput = __webpack_require__(27105);
;// CONCATENATED MODULE: ./components/AttachmentFileInput/AttachmentFileInput.tsx

















var AttachmentFileInput_cx = bind_default().bind((AttachmentFileInput_module_default()));
var AttachmentFileInput = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(AttachmentFileInput, Component);
    var _super = (0,_create_super/* default */.Z)(AttachmentFileInput);
    function AttachmentFileInput(props) {
        (0,_class_call_check/* default */.Z)(this, AttachmentFileInput);
        var _this;
        _this = _super.call(this, props);
        _this.handleUploadError = function(errorMessage) {
            _this.setState({
                errorMessage: errorMessage
            });
        };
        _this.handleUploadSuccess = function(file) {
            var onChange = _this.props.onChange;
            var attachment = {
                attachmentType: file.type,
                fileName: file.name,
                fileSizeInBytes: file.size,
                url: "https://".concat(file.container, ".").concat(constants/* AWS_S3_URL */.qL, "/").concat(file.key)
            };
            _this.setState({
                errorMessage: "",
                attachment: attachment
            });
            onChange({
                fileName: file.name,
                fileSizeInBytes: file.size,
                filestackId: file.handle,
                s3Key: file.key,
                s3Bucket: file.container,
                url: "https://".concat(file.container, ".").concat(constants/* AWS_S3_URL */.qL, "/").concat(file.key),
                // We need to nullify this, as it is only used for video attachments
                attachmentUrl: undefined
            });
        };
        _this.handleRemoveFile = function() {
            var onChange = _this.props.onChange;
            _this.setState({
                attachment: null
            });
            onChange(undefined);
        };
        _this.handleAltTextChange = function(value) {
            var onAltTextChange = _this.props.onAltTextChange;
            onAltTextChange === null || onAltTextChange === void 0 ? void 0 : onAltTextChange(value);
        };
        _this.handleUpload = function() {
            var _props = _this.props, onUploading = _props.onUploading, onFilePickerOpen = _props.onFilePickerOpen;
            onUploading === null || onUploading === void 0 ? void 0 : onUploading();
            onFilePickerOpen === null || onFilePickerOpen === void 0 ? void 0 : onFilePickerOpen(false);
        };
        var _attachment = props.attachment, attachment = _attachment === void 0 ? null : _attachment;
        _this.state = {
            errorMessage: "",
            attachment: attachment
        };
        return _this;
    }
    var _proto = AttachmentFileInput.prototype;
    _proto.render = function render() {
        var _props = this.props, accept = _props.accept, buttonLabel = _props.buttonLabel, clientOptions = _props.clientOptions, hasImagePreview = _props.hasImagePreview, maxFileSizeInMb = _props.maxFileSizeInMb, onClose = _props.onClose, s3UploadPath = _props.s3UploadPath, uploadingLabel = _props.uploadingLabel, t = _props.t, altText = _props.altText, isPostForm = _props.isPostForm, onFilePickerOpen = _props.onFilePickerOpen;
        var hideDivider = !!onClose;
        var hideCloseButton = !!onClose;
        var _state = this.state, errorMessage = _state.errorMessage, attachment = _state.attachment;
        var hasImageAttachmentType = attachment && attachment.attachmentType && attachment.attachmentType.match(/image/);
        if (attachment) {
            // @ts-ignore we will only have fileName if an existing image is passed in
            var imageName = attachment.fileName || "";
            // @ts-ignore we will only have fileName if an existing image is passed in
            var fileName = attachment.fileName || "";
            // @ts-ignore we will only have fileName if an existing image is passed in
            var fileSizeInBytes = attachment.fileSizeInBytes || 0;
            return hasImagePreview && hasImageAttachmentType ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    hideDivider && /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: AttachmentFileInput_cx("file-input__separator")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachmentFileInput_ImagePreview, {
                        imageName: imageName,
                        imageUrl: attachment.url || "",
                        t: t,
                        onRemove: this.handleRemoveFile
                    }),
                    !isPostForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachmentAltTextInput/* default */.Z, {
                        t: t,
                        value: altText || "",
                        onChange: this.handleAltTextChange
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachmentFileInput_FilePreview, {
                fileName: fileName,
                fileSizeInBytes: fileSizeInBytes,
                t: t,
                onRemove: this.handleRemoveFile
            });
        }
        return !attachment && /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleFilePicker_SimpleFilePicker, {
            accept: accept,
            ariaControls: "file-attachment-preview",
            awsRegion: "us-east-1",
            clientOptions: clientOptions,
            filestackAPIKey: "AJlfu1IB1Q9mpicgMdkVzz",
            maxFileSizeInMb: maxFileSizeInMb,
            render: function(param) {
                var openPicker = param.openPicker, isUploading = param.isUploading;
                var onOpenPicker = function() {
                    openPicker();
                    onFilePickerOpen === null || onFilePickerOpen === void 0 ? void 0 : onFilePickerOpen(true);
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: AttachmentFileInput_cx("file-input", {
                        "has-error": errorMessage
                    }),
                    children: [
                        hideCloseButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            appearance: "knockout",
                            ariaLabel: t("Close file input"),
                            className: AttachmentFileInput_cx("close-button"),
                            isDisabled: isUploading,
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                name: "x-dismiss"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.ZP, {
                            appearance: "default",
                            className: AttachmentFileInput_cx("file-input__upload-button"),
                            "data-qa": "space-image-upload__button",
                            isDisabled: isUploading,
                            size: "small",
                            onClick: onOpenPicker,
                            children: [
                                isUploading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: AttachmentFileInput_cx("file-input__upload-text"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularSpinner/* default */.Z, {
                                            color: "#ffffff",
                                            variation: "small"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: AttachmentFileInput_cx("file-input__upload-spinner"),
                                            children: uploadingLabel
                                        })
                                    ]
                                }),
                                !isUploading && buttonLabel
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Caption */.Y, {
                            className: AttachmentFileInput_cx("file-input__caption"),
                            "data-qa": "file-attachment__caption",
                            role: errorMessage ? "alert" : undefined,
                            children: errorMessage || /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: t("components-attachmentFileInput-maximum_size", "Maximum {{maxFileSizeInMb}}MB file size", {
                                            maxFileSizeInMb: maxFileSizeInMb
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: constants/* FILE_TYPES_ARTICLE */.IP,
                                            rel: "noopener noreferrer",
                                            target: "_blank",
                                            children: t("components-attachmentFileInput-accepted_files", "View the full list of accepted files")
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                });
            },
            s3Bucket: "thinkific-import",
            s3Path: s3UploadPath,
            onError: this.handleUploadError,
            onSuccess: this.handleUploadSuccess,
            onUploading: this.handleUpload
        });
    };
    return AttachmentFileInput;
}(react.Component);
// eslint-disable-next-line react/static-property-placement
AttachmentFileInput.defaultProps = {
    accept: constants/* ACCEPTED_FILE_TYPES */._0,
    altText: "",
    attachment: null,
    hasImagePreview: false,
    isPostForm: false,
    maxFileSizeInMb: 5,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: function() {}
};
/* harmony default export */ var AttachmentFileInput_AttachmentFileInput = ((0,esm/* withTranslation */.Zh)()(AttachmentFileInput));

;// CONCATENATED MODULE: ./components/AttachmentFileInput/index.ts


// EXTERNAL MODULE: ./koba/components/Input/index.js + 1 modules
var Input = __webpack_require__(44586);
// EXTERNAL MODULE: ./node_modules/react-player/lazy/index.js
var lazy = __webpack_require__(56310);
var lazy_default = /*#__PURE__*/__webpack_require__.n(lazy);
// EXTERNAL MODULE: ./utils/urlParser.ts
var urlParser = __webpack_require__(90312);
// EXTERNAL MODULE: ./components/AttachmentVideoInput/AttachmentVideoInput.module.scss
var AttachmentVideoInput_module = __webpack_require__(19329);
var AttachmentVideoInput_module_default = /*#__PURE__*/__webpack_require__.n(AttachmentVideoInput_module);
// EXTERNAL MODULE: ./components/AttachmentVideoInput/LoomPreview.tsx
var LoomPreview = __webpack_require__(6929);
;// CONCATENATED MODULE: ./components/AttachmentVideoInput/VideoPreview.tsx









var VideoPreview_cx = bind_default().bind((AttachmentVideoInput_module_default()));
var VideoPreview = function(param) {
    var videoUrl = param.videoUrl, onRemove = param.onRemove;
    var loomId = (0,urlParser/* parseLoomId */.Y)(videoUrl);
    var player = null;
    if (loomId) {
        player = /*#__PURE__*/ (0,jsx_runtime.jsx)(LoomPreview/* default */.Z, {
            loomId: loomId
        });
    } else {
        player = /*#__PURE__*/ (0,jsx_runtime.jsx)((lazy_default()), {
            height: "320px",
            url: videoUrl,
            width: "100%",
            controls: true
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "aria-live": "polite",
        className: VideoPreview_cx("video-attachment__preview-container"),
        id: "video-attachment-preview",
        role: "region",
        title: "Video Preview",
        children: [
            player,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                appearance: "default",
                ariaLabel: "Remove video",
                className: VideoPreview_cx("remove-video-button"),
                onClick: onRemove,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    name: "x-dismiss"
                })
            })
        ]
    });
};
/* harmony default export */ var AttachmentVideoInput_VideoPreview = (VideoPreview);

;// CONCATENATED MODULE: ./components/AttachmentVideoInput/AttachmentVideoInput.tsx














var AttachmentVideoInput_cx = bind_default().bind((AttachmentVideoInput_module_default()));
var AttachmentVideoInput = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(AttachmentVideoInput, Component);
    var _super = (0,_create_super/* default */.Z)(AttachmentVideoInput);
    function AttachmentVideoInput(props) {
        (0,_class_call_check/* default */.Z)(this, AttachmentVideoInput);
        var _this;
        _this = _super.call(this, props);
        _this.handleUploadVideo = function() {
            var onChange = _this.props.onChange;
            var videoUrl = _this.state.videoUrl;
            if (_this.handleValidation()) {
                _this.setState({
                    isVideoUploaded: true
                });
                onChange({
                    // We need to nullify these, as it is only used for file/image attachments
                    fileName: undefined,
                    fileSizeInBytes: undefined,
                    filestackId: undefined,
                    s3Key: undefined,
                    s3Bucket: undefined,
                    // Both are needed to display the video in the post, and the preview
                    // in the edit modal
                    url: videoUrl,
                    attachmentUrl: videoUrl
                });
            }
        };
        _this.handleRemoveVideo = function() {
            var onChange = _this.props.onChange;
            _this.setState({
                isVideoUploaded: false,
                videoUrl: "",
                errorMessage: ""
            });
            onChange(undefined);
        };
        _this.handleChange = function(value) {
            _this.setState({
                videoUrl: value
            });
        };
        _this.handleValidation = function() {
            var videoUrl = _this.state.videoUrl;
            var t = _this.props.t;
            var errorMessage;
            var urlIsValid = true;
            var isPlayableUrl = lazy_default().canPlay(videoUrl) || (0,urlParser/* isLoomUrl */.q)(videoUrl);
            if (!isPlayableUrl) {
                urlIsValid = false;
                errorMessage = t("Invalid URL");
            }
            _this.setState({
                errorMessage: errorMessage
            });
            return urlIsValid;
        };
        _this.disableAddVideoButton = function() {
            var videoUrl = _this.state.videoUrl;
            return videoUrl.length === 0 || !videoUrl;
        };
        var attachmentUrl = props.attachmentUrl;
        _this.state = {
            videoUrl: attachmentUrl || "",
            isVideoUploaded: !!attachmentUrl,
            errorMessage: ""
        };
        return _this;
    }
    var _proto = AttachmentVideoInput.prototype;
    _proto.render = function render() {
        var _props = this.props, buttonLabel = _props.buttonLabel, onClose = _props.onClose, cancelButtonLabel = _props.cancelButtonLabel, inputLabel = _props.inputLabel, attachmentUrl = _props.attachmentUrl, t = _props.t;
        var _state = this.state, isVideoUploaded = _state.isVideoUploaded, videoUrl = _state.videoUrl, errorMessage = _state.errorMessage;
        if (isVideoUploaded) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachmentVideoInput_VideoPreview, {
                videoUrl: videoUrl,
                onRemove: this.handleRemoveVideo
            });
        }
        return !attachmentUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: AttachmentVideoInput_cx("video-attachment__wrapper"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    ariaControls: "video-attachment-preview",
                    extraClasses: AttachmentVideoInput_cx(errorMessage ? "input--failure" : ""),
                    handleChange: this.handleChange,
                    id: "video-url",
                    initValue: videoUrl,
                    label: inputLabel,
                    name: "video-url",
                    placeholder: "https://www.example.com",
                    type: "url",
                    wrapperClass: AttachmentVideoInput_cx("video-attachment__input"),
                    required: true
                }),
                errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    role: "alert",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Caption */.Y, {
                        className: "error-message",
                        children: errorMessage
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Caption */.Y, {
                    children: t("components-attachmentVideoInput-supported_video_platforms_tip", "Supported Platforms: YouTube, Vimeo, Loom")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: AttachmentVideoInput_cx("video-attachment__action-buttons"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            appearance: "ghost",
                            size: "small",
                            onClick: onClose,
                            children: cancelButtonLabel
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            isDisabled: this.disableAddVideoButton(),
                            size: "small",
                            onClick: this.handleUploadVideo,
                            children: buttonLabel
                        })
                    ]
                })
            ]
        });
    };
    return AttachmentVideoInput;
}(react.Component);
/* harmony default export */ var AttachmentVideoInput_AttachmentVideoInput = ((0,esm/* withTranslation */.Zh)()(AttachmentVideoInput));

;// CONCATENATED MODULE: ./components/AttachmentVideoInput/index.ts


// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Tooltip-00b73669.js
var Tooltip_00b73669 = __webpack_require__(20021);
// EXTERNAL MODULE: ./components/AttachmentButtons/AttachmentButtons.module.scss
var AttachmentButtons_module = __webpack_require__(31466);
var AttachmentButtons_module_default = /*#__PURE__*/__webpack_require__.n(AttachmentButtons_module);
;// CONCATENATED MODULE: ./components/AttachmentButtons/CommentAttachmentButtons.tsx







var CommentAttachmentButtons_cx = bind_default().bind((AttachmentButtons_module_default()));
var CommentAttachmentButtons = function(param) {
    var openAttachment = param.openAttachment, buttonsDisabled = param.buttonsDisabled, attachmentButtonData = param.attachmentButtonData;
    var buttons = attachmentButtonData.map(function(param) {
        var tooltipTitle = param.tooltipTitle, attachmentType = param.attachmentType, iconName = param.iconName, dataQA = param.dataQA;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_00b73669.T, {
            className: CommentAttachmentButtons_cx("attachment__buttons__comment"),
            title: buttonsDisabled ? "" : tooltipTitle,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* ButtonWithIconOnly */.Au, {
                appearance: "knockout",
                "aria-label": tooltipTitle,
                "data-qa": dataQA,
                isDisabled: buttonsDisabled,
                onClick: openAttachment(attachmentType),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    name: iconName
                })
            })
        }, tooltipTitle);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: buttons
    });
};
/* harmony default export */ var AttachmentButtons_CommentAttachmentButtons = (CommentAttachmentButtons);

;// CONCATENATED MODULE: ./components/AttachmentButtons/PostAttachmentButtons.tsx




var PostAttachmentButtons = function(param) {
    var openAttachment = param.openAttachment, buttonsDisabled = param.buttonsDisabled, attachmentButtonData = param.attachmentButtonData;
    var buttons = attachmentButtonData.map(function(param) {
        var title = param.title, attachmentType = param.attachmentType, iconName = param.iconName, dataQA = param.dataQA;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* ButtonWithIconLeft */.ej, {
            appearance: "ghost",
            className: "",
            "data-qa": dataQA,
            isDisabled: buttonsDisabled,
            size: "small",
            onClick: openAttachment(attachmentType),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    name: iconName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: title
                })
            ]
        }, title);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: buttons
    });
};
/* harmony default export */ var AttachmentButtons_PostAttachmentButtons = (PostAttachmentButtons);

;// CONCATENATED MODULE: ./components/AttachmentButtons/AttachmentButtons.tsx














var AttachmentButtons_cx = bind_default().bind((AttachmentButtons_module_default()));
var AttachmentButtons = function(param) {
    var attachment = param.attachment, isAttachmentRenderedInPortal = param.isAttachmentRenderedInPortal, isDisabled = param.isDisabled, isIconOnly = param.isIconOnly, isPostForm = param.isPostForm, s3UploadPath = param.s3UploadPath, _altText = param.altText, altText = _altText === void 0 ? "" : _altText, onAltTextChange = param.onAltTextChange, onChange = param.onChange, onUploading = param.onUploading, onAttachmentClicked = param.onAttachmentClicked, inputRef = param.inputRef, onFilePickerOpen = param.onFilePickerOpen;
    var t = (0,es/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(attachment ? attachment.attachmentType : null), attachmentType = ref[0], setAttachmentType = ref[1]; // Attachment type can be file | image | video or a mimetype
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isMobile = width < constants/* BREAKPOINT_MD */.GI;
    var currentRef = (0,react.useRef)(null);
    var filestackSecurity = (0,CommunityContext/* useCommunityContext */.v1)().filestackSecurity;
    var openAttachment = function(postAttachmentType) {
        return function() {
            setAttachmentType(postAttachmentType);
            focusInput();
            onAttachmentClicked === null || onAttachmentClicked === void 0 ? void 0 : onAttachmentClicked();
        };
    };
    var removeAttachment = function() {
        setAttachmentType(null);
        onChange(null);
        focusInput();
    };
    var handleAttachmentChange = function(postAttachment) {
        if (postAttachment && attachmentType) {
            onChange((0,_object_spread/* default */.Z)({
                attachmentType: attachmentType
            }, postAttachment));
        } else {
            onChange(null);
        }
        focusInput();
    };
    var handleAttachmentAltTextChange = function(text) {
        onAltTextChange === null || onAltTextChange === void 0 ? void 0 : onAltTextChange(text);
    };
    var focusInput = function() {
        if (isAttachmentRenderedInPortal && inputRef) {
            var ref;
            inputRef === null || inputRef === void 0 ? void 0 : (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    };
    var renderAttachmentInput = function() {
        var attachmentInputProps = {
            onChange: handleAttachmentChange,
            onClose: removeAttachment,
            uploadingLabel: t("components-attachmentButtons-uploading", "Uploading...")
        };
        switch(attachmentType){
            case constants/* IMAGE_ATTACHMENT */.PZ:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachmentFileInput_AttachmentFileInput, (0,_object_spread/* default */.Z)({
                    accept: constants/* ACCEPTED_IMAGE_TYPES */.dr,
                    altText: altText,
                    attachment: attachment,
                    buttonLabel: t("Upload image"),
                    clientOptions: filestackSecurity,
                    isPostForm: isPostForm,
                    maxFileSizeInMb: constants/* MAX_FILE_SIZE_MB */.C1,
                    s3UploadPath: s3UploadPath,
                    hasImagePreview: true,
                    onAltTextChange: handleAttachmentAltTextChange,
                    onFilePickerOpen: onFilePickerOpen,
                    onUploading: onUploading
                }, attachmentInputProps));
            case constants/* FILE_ATTACHMENT */.d7:
                // TODO: Copy the accepted file types from course-builder
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachmentFileInput_AttachmentFileInput, (0,_object_spread/* default */.Z)({
                    accept: constants/* ACCEPTED_FILE_TYPES */._0,
                    attachment: attachment,
                    buttonLabel: t("Upload file"),
                    clientOptions: filestackSecurity,
                    maxFileSizeInMb: constants/* MAX_FILE_SIZE_MB */.C1,
                    s3UploadPath: s3UploadPath,
                    onFilePickerOpen: onFilePickerOpen,
                    onUploading: onUploading
                }, attachmentInputProps));
            case constants/* VIDEO_ATTACHMENT */.wh:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachmentVideoInput_AttachmentVideoInput, (0,_object_spread/* default */.Z)({
                    attachmentUrl: attachment ? attachment.url : "",
                    buttonLabel: t("Add video"),
                    cancelButtonLabel: t("Cancel"),
                    inputLabel: t("Video URL")
                }, attachmentInputProps));
            default:
                return null;
        }
    };
    var AttachmentInputPortal = function() {
        var ref;
        if (!isAttachmentRenderedInPortal) {
            return renderAttachmentInput();
        }
        var currentEl = currentRef.current;
        if (!currentEl) {
            return null;
        }
        var portalEl = (ref = currentEl.closest(".actions")) === null || ref === void 0 ? void 0 : ref.querySelector(".attachment-input__portal");
        if (!portalEl) return null;
        return portalEl && /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: AttachmentButtons_cx("attachment-input__container"),
            children: renderAttachmentInput()
        }), portalEl);
    };
    var buttonsDisabled = isDisabled || !!attachmentType;
    var isMobileCommentView = isIconOnly && isMobile;
    var attachmentButtonData = [
        {
            tooltipTitle: t("Upload image"),
            title: t("IMAGE"),
            attachmentType: constants/* IMAGE_ATTACHMENT */.PZ,
            iconName: "image",
            dataQA: "create-post-image__button"
        },
        {
            tooltipTitle: t("Add video"),
            title: t("VIDEO"),
            attachmentType: constants/* VIDEO_ATTACHMENT */.wh,
            iconName: "content-video",
            dataQA: "create-post-video__button"
        },
        {
            tooltipTitle: t("Upload file"),
            title: t("FILE"),
            attachmentType: constants/* FILE_ATTACHMENT */.d7,
            iconName: "page",
            dataQA: "create-post-file__button"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: AttachmentButtons_cx("attachment"),
            "data-qa": "attachment",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: AttachmentButtons_cx("attachment__input"),
                    ref: currentRef,
                    children: !isMobileCommentView && /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachmentInputPortal, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: AttachmentButtons_cx("attachment__buttons", {
                        "attachment__buttons--icon-only": isIconOnly
                    }),
                    children: isIconOnly ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachmentButtons_CommentAttachmentButtons, {
                        attachmentButtonData: attachmentButtonData,
                        buttonsDisabled: buttonsDisabled,
                        openAttachment: openAttachment
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: !attachment && /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachmentButtons_PostAttachmentButtons, {
                            attachmentButtonData: attachmentButtonData,
                            buttonsDisabled: buttonsDisabled,
                            openAttachment: openAttachment
                        })
                    })
                }),
                isMobileCommentView && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: AttachmentButtons_cx("attachment__mobile-input"),
                    children: renderAttachmentInput()
                })
            ]
        })
    });
};
// Apparently we need React.memo otherwise the loading indicator on image uploads doesn't appear...
/* harmony default export */ var AttachmentButtons_AttachmentButtons = (/*#__PURE__*/react.memo(AttachmentButtons));

;// CONCATENATED MODULE: ./components/AttachmentButtons/index.ts



/***/ }),

/***/ 27105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AttachmentAltTextInput */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var koba_components_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8236);
/* harmony import */ var koba_components_Label__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23185);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20021);
/* harmony import */ var koba_components_Input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44586);
/* harmony import */ var _AttachmentFileInput_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94917);
/* harmony import */ var _AttachmentFileInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_AttachmentFileInput_module_scss__WEBPACK_IMPORTED_MODULE_6__);








var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_AttachmentFileInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default()));
var AttachmentAltTextInput = function(param) {
    var value = param.value, onChange = param.onChange, t = param.t, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(koba_components_Label__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                className: cx("file-input__label-with-tooltip"),
                htmlFor: "image-alt",
                children: [
                    t("Alternative text (optional)"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_7__.T, {
                        className: cx("file-input__tooltip"),
                        title: t("Alternative text describes your image to people with visual impairments"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: cx("file-input__tooltip-icon"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(koba_components_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                name: "circle-outline-info"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(koba_components_Input__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                extraProps: {
                    maxLength: 100
                },
                handleChange: onChange,
                id: "image-alt",
                initValue: value,
                isDisabled: isDisabled,
                name: "image-alt",
                type: "text",
                wrapperClass: cx("file-input__image-alt")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AttachmentAltTextInput);


/***/ }),

/***/ 6929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67421);
/* harmony import */ var _LoomPreview_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93112);
/* harmony import */ var _LoomPreview_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_LoomPreview_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_LoomPreview_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
var LoomPreview = function(param) {
    var loomId = param.loomId;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: cx("loom-preview"),
        "data-qa": "loom-preview",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
            className: cx("loom-preview__iframe"),
            src: "https://www.loom.com/embed/".concat(loomId),
            title: t("components-attachmentVideoInput-loom_title", "Loom Video Preview"),
            allowFullScreen: true
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoomPreview);


/***/ }),

/***/ 52655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ExpandableTextArea_ExpandableTextArea; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./node_modules/emoji-mart/dist-es/index.js + 29 modules
var dist_es = __webpack_require__(37757);
// EXTERNAL MODULE: ./node_modules/emoji-mart/css/emoji-mart.css
var emoji_mart = __webpack_require__(87898);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Tooltip-00b73669.js
var Tooltip_00b73669 = __webpack_require__(20021);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./components/EmojiPicker/EmojiPicker.module.scss
var EmojiPicker_module = __webpack_require__(81910);
var EmojiPicker_module_default = /*#__PURE__*/__webpack_require__.n(EmojiPicker_module);
;// CONCATENATED MODULE: ./components/EmojiPicker/EmojiPickerDictionary.ts
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var getDictionary = function(t) {
    return {
        search: t("Search"),
        clear: t("Clear"),
        notfound: t("No Emoji Found"),
        skintext: t("Choose your default skin tone"),
        categories: {
            search: t("Search Results"),
            recent: t("Frequently Used"),
            people: t("Smileys & People"),
            nature: t("Animals & Nature"),
            foods: t("Food & Drink"),
            activity: t("Activity"),
            places: t("Travel & Places"),
            objects: t("Objects"),
            symbols: t("Symbols"),
            flags: t("Flags"),
            custom: t("Custom")
        },
        categorieslabel: t("Emoji categories"),
        skintones: {
            1: t("Default Skin Tone"),
            2: t("Light Skin Tone"),
            3: t("Medium-Light Skin Tone"),
            4: t("Medium Skin Tone"),
            5: t("Medium-Dark Skin Tone"),
            6: t("Dark Skin Tone")
        }
    };
};
/* harmony default export */ var EmojiPickerDictionary = (getDictionary);

;// CONCATENATED MODULE: ./components/EmojiPicker/EmojiPicker.tsx










var cx = bind_default().bind((EmojiPicker_module_default()));
var EmojiPicker = function(param) {
    var onDismiss = param.onDismiss, onPick = param.onPick, _position = param.position, position = _position === void 0 ? "right" : _position, t = param.t;
    var ref = (0,react.useState)(false), isPickerDisplayed = ref[0], setIsPickerDisplayed = ref[1];
    var handleSelect = function(emoji) {
        var native = emoji.native;
        // eslint-disable-next-line no-unused-expressions
        native && onPick(native);
        setIsPickerDisplayed(false);
    };
    var handleDismiss = function() {
        setIsPickerDisplayed(false);
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx("emoji-picker"),
        "data-qa": "emoji-picker",
        children: [
            isPickerDisplayed && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx("emoji-picker__emoji-mart", "emoji-picker__emoji-mart--".concat(position)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "aria-label": t("Close emoji picker"),
                        className: cx("emoji-picker__overlay"),
                        role: "button",
                        tabIndex: 0,
                        onClick: handleDismiss,
                        onKeyPress: handleDismiss
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es/* Picker */.cW, {
                        i18n: EmojiPickerDictionary(t),
                        showPreview: false,
                        showSkinTones: false,
                        autoFocus: true,
                        emojiTooltip: true,
                        native: true,
                        onSelect: handleSelect
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_00b73669.T, {
                title: t("Add emoji"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                    appearance: "knockout",
                    ariaLabel: isPickerDisplayed ? t("Close emoji picker") : t("Add emoji"),
                    className: cx("emoji-picker__button", "button--icon-only"),
                    size: "small",
                    onClick: function() {
                        setIsPickerDisplayed(true);
                    },
                    children: isPickerDisplayed ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        height: "24",
                        viewBox: "4 1 19 19",
                        width: "24",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            fill: "none",
                            fillRule: "evenodd",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M12,6 C8.7,6 6,8.7 6,12 C6,15.3 8.7,18 12,18 C15.3,18 18,15.3 18,12 C18,8.7 15.3,6 12,6 Z",
                                    fill: "#FFE300"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M12,6 C15.3,6 18,8.7 18,12 C18,15.3 15.3,18 12,18 C8.7,18 6,15.3 6,12 C6,8.7 8.7,6 12,6 Z M12,6.70588235 C9.08823529,6.70588235 6.70588235,9.08823529 6.70588235,12 C6.70588235,14.9117647 9.08823529,17.2941176 12,17.2941176 C14.9117647,17.2941176 17.2941176,14.9117647 17.2941176,12 C17.2941176,9.08823529 14.9117647,6.70588235 12,6.70588235 Z M9.63529412,13.8705882 C9.77647059,13.7294118 9.98823529,13.7294118 10.1294118,13.8705882 C11.1529412,14.8941176 12.8470588,14.8941176 13.8705882,13.8705882 C14.0117647,13.7294118 14.2235294,13.7294118 14.3647059,13.8705882 C14.5058824,14.0117647 14.5058824,14.2235294 14.3647059,14.3647059 C13.7117647,15.0176471 12.8647059,15.3529412 12,15.3529412 C11.1352941,15.3529412 10.2882353,15.0176471 9.63529412,14.3647059 C9.49411765,14.2235294 9.49411765,14.0117647 9.63529412,13.8705882 Z M10.2352941,9.70588235 C10.7226042,9.70588235 11.1176471,10.1009252 11.1176471,10.5882353 C11.1176471,11.0755454 10.7226042,11.4705882 10.2352941,11.4705882 C9.74798404,11.4705882 9.35294118,11.0755454 9.35294118,10.5882353 C9.35294118,10.1009252 9.74798404,9.70588235 10.2352941,9.70588235 Z M13.7647059,9.70588235 C14.252016,9.70588235 14.6470588,10.1009252 14.6470588,10.5882353 C14.6470588,11.0755454 14.252016,11.4705882 13.7647059,11.4705882 C13.2773958,11.4705882 12.8823529,11.0755454 12.8823529,10.5882353 C12.8823529,10.1009252 13.2773958,9.70588235 13.7647059,9.70588235 Z",
                                    fill: "#000",
                                    fillRule: "nonzero"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        name: "smiley-face"
                    })
                })
            }, "Add Emoji")
        ]
    });
};
/* harmony default export */ var EmojiPicker_EmojiPicker = (EmojiPicker);

;// CONCATENATED MODULE: ./components/EmojiPicker/index.ts


// EXTERNAL MODULE: ./components/AttachmentButtons/index.ts + 12 modules
var AttachmentButtons = __webpack_require__(40294);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./utils/textHelpers.ts
var textHelpers = __webpack_require__(51661);
// EXTERNAL MODULE: ./utils/mentions/index.ts
var mentions = __webpack_require__(29296);
// EXTERNAL MODULE: ./koba/components/Label/index.ts + 1 modules
var Label = __webpack_require__(23185);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./components/ExpandableTextArea/ExpandableTextArea.module.scss
var ExpandableTextArea_module = __webpack_require__(46666);
var ExpandableTextArea_module_default = /*#__PURE__*/__webpack_require__.n(ExpandableTextArea_module);
;// CONCATENATED MODULE: ./components/ExpandableTextArea/ExpandableTextArea.tsx














var ExpandableTextArea_cx = bind_default().bind((ExpandableTextArea_module_default()));
var ExpandableTextArea = function(param) {
    var attachment = param.attachment, attachmentAltText = param.attachmentAltText, cancelComment = param.cancelComment, color = param.color, handleAttachmentAltTextChange = param.handleAttachmentAltTextChange, handleAttachmentChange = param.handleAttachmentChange, handleBlur = param.handleBlur, handleInputChange = param.handleInputChange, id = param.id, mentionsComponent = param.mentionsComponent, parentPassedRef = param.inputRef, isAlwaysExpanded = param.isAlwaysExpanded, isAttachmentButtonsEnabled = param.isAttachmentButtonsEnabled, isAttachmentRenderedInPortal = param.isAttachmentRenderedInPortal, isEditing = param.isEditing, isModal = param.isModal, isReply = param.isReply, isSubmitDisabled = param.isSubmitDisabled, label = param.label, labelClass = param.labelClass, parentPostRef = param.parentPostRef, _s3UploadPath = param.s3UploadPath, s3UploadPath = _s3UploadPath === void 0 ? "" : _s3UploadPath, submitComment = param.submitComment, t = param.t, value = param.value;
    var cancelButtonRef = react.useRef(null);
    var postButtonRef = react.useRef(null);
    var inputRef = react.useRef();
    var containerClassName = "expandable-text__container";
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isDesktop = width >= constants/* BREAKPOINT_MD */.GI;
    var ref = (0,react.useState)(false), recomputePortal = ref[0], setRecomputePortal = ref[1];
    var ref1 = (0,react.useState)(true), isAttachmentOpen = ref1[0], setIsAttachmentOpen = ref1[1];
    var ref2 = (0,react.useState)(false), isAttachmentUploading = ref2[0], setIsAttachmentUploading = ref2[1];
    var ref3 = (0,react.useState)(isAlwaysExpanded), isExpanded = ref3[0], setIsExpanded = ref3[1];
    var expandedClassName = isExpanded ? "".concat(containerClassName, "--expanded") : "";
    var blurExpandableTextarea = function(cancelRef, buttonRef, parentRef) {
        cancelRef.blur();
        buttonRef.blur();
        if (!isEditing) {
            parentRef.focus();
            blurTextarea();
            // TODO: fix this ridiculous hack to close the FileAttachmentInput after submitting a comment
            setIsAttachmentOpen(false);
            setIsAttachmentOpen(true);
        }
    };
    var getInputRef = function() {
        return parentPassedRef ? parentPassedRef.current : inputRef.current;
    };
    (0,react.useEffect)(function() {
        // re-calculate the portal element after the component is mounted
        if (isAttachmentRenderedInPortal) {
            setRecomputePortal(true);
        }
    }, []);
    var handleCancelComment = function(cancelButton, postButton, parentPost) {
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var cancelRef, postRef, parentRef;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        cancelRef = cancelButton.current;
                        postRef = postButton.current;
                        parentRef = parentPost.current;
                        if (!cancelComment) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 6;
                        return cancelComment();
                    case 6:
                        blurExpandableTextarea(cancelRef, postRef, parentRef);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    };
    var handleEmojiPick = function(emoji) {
        var inputElement = getInputRef();
        if (inputElement) {
            var selectionStart = inputElement.selectionStart, inputValue = inputElement.value;
            var updatedContent = (0,mentions/* insertEmoji */.Q0)(emoji, selectionStart, inputValue, value);
            handleInputChange(updatedContent);
            inputElement.focus();
        }
    };
    var handleSubmitComment = function(cancelButton, postButton, parentPost) {
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var cancelElement, postElement, parentElement;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        cancelElement = cancelButton.current;
                        postElement = postButton.current;
                        parentElement = parentPost.current;
                        focusTextarea();
                        if (!submitComment) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 7;
                        return submitComment();
                    case 7:
                        blurExpandableTextarea(cancelElement, postElement, parentElement);
                        if (handleBlur) handleBlur();
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    };
    var primaryBtnText = isReply ? "Post reply" : "Post comment";
    var handleOnBlur = function(e) {
        if (!isReply) {
            return;
        }
        var currentTarget = e.currentTarget;
        setTimeout(function() {
            if (!currentTarget.contains(document.activeElement)) {
                var ref = getInputRef();
                if (ref) {
                    var ref1;
                    var val = (ref1 = getInputRef()) === null || ref1 === void 0 ? void 0 : ref1.value;
                    if (!val) {
                        if (handleBlur) handleBlur();
                    }
                }
            }
        }, 0);
    };
    var onAttachmentAltTextChange = (0,react.useCallback)(function(altText) {
        if (handleAttachmentAltTextChange) handleAttachmentAltTextChange(altText);
    }, [
        attachment
    ]);
    var onAttachmentChange = (0,react.useCallback)(function(newAttachment) {
        setIsExpanded(newAttachment !== null);
        setIsAttachmentUploading(false);
        if (handleAttachmentChange) handleAttachmentChange(newAttachment);
    }, [
        attachment,
        recomputePortal
    ]);
    var onAttachmentUploading = (0,react.useCallback)(function() {
        setIsAttachmentUploading(true);
        focusTextarea();
    }, [
        attachment,
        recomputePortal
    ]);
    var onFilePickerOpen = (0,react.useCallback)(function(isExpandedLocal) {
        setIsExpanded(isExpandedLocal); // when the file picker is open, keep the textarea expanded
    }, [
        attachment,
        recomputePortal
    ]);
    var executeMethodsOnTextarea = function() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _method = ref.method, method = _method === void 0 ? "focus" : _method;
        if (parentPassedRef && parentPassedRef.current) {
            // @ts-ignore
            var input = parentPassedRef.current.input;
            input = parentPassedRef.current;
            input[method]();
        } else if (inputRef && inputRef.current) {
            // @ts-ignore
            var input1 = inputRef.current.input;
            input1 = inputRef.current;
            input1[method]();
        }
    };
    var focusTextarea = function() {
        executeMethodsOnTextarea();
    };
    var blurTextarea = function() {
        executeMethodsOnTextarea({
            method: "blur"
        });
    };
    var onFocusTextarea = (0,react.useCallback)(function() {
        return focusTextarea();
    }, [
        attachment
    ]);
    var clonedMentionsArea = /*#__PURE__*/ react.cloneElement(mentionsComponent, {
        forwardRef: parentPassedRef || inputRef,
        isExpanded: isExpanded
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ExpandableTextArea_cx("full-width", {
            "mentions-enabled-post-detail":  true && !isModal
        }),
        onBlur: handleOnBlur,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                className: ExpandableTextArea_cx("expandable-text__label", labelClass),
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: ExpandableTextArea_cx(containerClassName, expandedClassName),
                tabIndex: -1,
                children: [
                    clonedMentionsArea,
                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: ExpandableTextArea_cx("actions"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "attachment-input__portal"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: ExpandableTextArea_cx("actions__wrapper"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: ExpandableTextArea_cx("actions__wrapper__left-container"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiPicker_EmojiPicker, {
                                                t: t,
                                                onDismiss: focusTextarea,
                                                onPick: handleEmojiPick
                                            }),
                                            isAttachmentButtonsEnabled && isAttachmentOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachmentButtons/* default */.Z, {
                                                altText: attachmentAltText,
                                                attachment: attachment,
                                                inputRef: parentPassedRef || inputRef,
                                                isAttachmentRenderedInPortal: isAttachmentRenderedInPortal,
                                                s3UploadPath: s3UploadPath,
                                                isIconOnly: true,
                                                onAltTextChange: onAttachmentAltTextChange,
                                                onAttachmentClicked: onFocusTextarea,
                                                onChange: onAttachmentChange,
                                                onFilePickerOpen: onFilePickerOpen,
                                                onUploading: onAttachmentUploading
                                            })
                                        ]
                                    }),
                                    parentPostRef && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                                appearance: "knockout",
                                                className: ExpandableTextArea_cx("actions__cancel"),
                                                ref: cancelButtonRef,
                                                size: "small",
                                                onClick: handleCancelComment(cancelButtonRef, postButtonRef, parentPostRef),
                                                children: t("common-cancel", "Cancel")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                                appearance: "default",
                                                color: color,
                                                dataQA: "save-changes__btn",
                                                isDisabled: !attachment && !(0,textHelpers/* isValidText */.Gq)(value) || isSubmitDisabled || isAttachmentUploading,
                                                ref: postButtonRef,
                                                size: "small",
                                                onClick: handleSubmitComment(cancelButtonRef, postButtonRef, parentPostRef),
                                                children: t(isEditing ? "Save changes" : primaryBtnText)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ExpandableTextArea_ExpandableTextArea = (ExpandableTextArea);

;// CONCATENATED MODULE: ./components/ExpandableTextArea/index.ts



/***/ }),

/***/ 68274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ FileSizeLabel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var FileSizeLabel = function(_param) {
    var byteCount = _param.byteCount, t = _param.t, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "byteCount",
        "t"
    ]);
    var shouldShowMB = byteCount > 1000000;
    var label;
    if (shouldShowMB) {
        var size = Math.round(byteCount / 1000000);
        label = t("({{size}} MB)", {
            size: size
        });
    } else {
        var size1 = Math.round(byteCount / 1000);
        label = t("({{size}} KB)", {
            size: size1
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        children: label
    }));
};



/***/ }),

/***/ 977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PostContainer_PostContainer; }
});

// UNUSED EXPORTS: PostContainer

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/toaster-a57afb61.js
var toaster_a57afb61 = __webpack_require__(81792);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Loader-fe940c7c.js
var Loader_fe940c7c = __webpack_require__(75826);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./schema/Post/queries.ts
var queries = __webpack_require__(95313);
// EXTERNAL MODULE: ./koba/components/InlineActions/constants.js
var InlineActions_constants = __webpack_require__(98939);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./helpers/dateHelpers/index.ts
var dateHelpers = __webpack_require__(17981);
// EXTERNAL MODULE: ./schema/Post/mutations.ts
var mutations = __webpack_require__(74266);
// EXTERNAL MODULE: ./constants/featureFlags.ts
var constants_featureFlags = __webpack_require__(46139);
// EXTERNAL MODULE: ./components/Post/components/PostHeader.tsx
var PostHeader = __webpack_require__(74883);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./helpers/reactionHelpers.ts
var reactionHelpers = __webpack_require__(72579);
// EXTERNAL MODULE: ./components/ReactionButton/index.ts + 3 modules
var ReactionButton = __webpack_require__(44215);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./components/Post/components/PostSpaceBadge.tsx
var PostSpaceBadge = __webpack_require__(87037);
// EXTERNAL MODULE: ./components/Post/Post.module.scss
var Post_module = __webpack_require__(82845);
var Post_module_default = /*#__PURE__*/__webpack_require__.n(Post_module);
;// CONCATENATED MODULE: ./components/Post/components/PostFooter.tsx











var cx = bind_default().bind((Post_module_default()));
var PostFooter = function(param) {
    var showSpaceTag = param.showSpaceTag, hasReacted = param.hasReacted, post = param.post, postReactionCount = param.postReactionCount, goToPost = param.goToPost, totalCommentCount = param.totalCommentCount, communityId = param.communityId, spaceId = param.spaceId, spaceName = param.spaceName, spaceIconName = param.spaceIconName;
    var t = (0,es/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx("post__footer", {
            "is-spaces-enabled": showSpaceTag
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactionButton/* default */.Z, {
                        hasReacted: hasReacted,
                        id: post.id,
                        isReactingTo: "post",
                        postReactionCount: postReactionCount,
                        reactionType: constants/* REACTION_TYPES.LIKE_POST */.B0.LIKE_POST,
                        reactors: (0,reactionHelpers/* getReactors */.U)(post),
                        t: t
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* ButtonWithIconLeft */.ej, {
                        appearance: "knockout",
                        "data-qa": "main-comments_text",
                        size: "small",
                        onClick: goToPost,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                name: "discussions"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("{{count}} comment", {
                                    count: totalCommentCount
                                })
                            })
                        ]
                    })
                ]
            }),
            showSpaceTag && spaceId && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostSpaceBadge/* default */.Z, {
                communityId: communityId,
                spaceIconName: spaceIconName,
                spaceId: spaceId,
                spaceName: spaceName
            })
        ]
    });
};
/* harmony default export */ var components_PostFooter = (PostFooter);

// EXTERNAL MODULE: ./components/Post/components/PostContent.tsx
var PostContent = __webpack_require__(43485);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./utils/mentions/index.ts
var mentions = __webpack_require__(29296);
// EXTERNAL MODULE: ./schema/Replies/queries.ts
var Replies_queries = __webpack_require__(28865);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./components/ExpandableTextArea/index.ts + 4 modules
var ExpandableTextArea = __webpack_require__(52655);
// EXTERNAL MODULE: ./components/UserAvatar/index.ts + 2 modules
var UserAvatar = __webpack_require__(82957);
;// CONCATENATED MODULE: ./components/Post/components/CommentSection.tsx


















var CommentSection_cx = bind_default().bind((Post_module_default()));
var CommentListSingular;
var AddCommentModal;
var CommentList;
var AddCommentContainer;
var MentionsTextArea;
var CommentSection = function(param) {
    var post = param.post, communityWrapperRef = param.communityWrapperRef, lastCommentRef = param.lastCommentRef, postRef = param.postRef, onPostChange = param.onPostChange, onCommentSubmitted = param.onCommentSubmitted, author = param.author, additionalClassName = param.additionalClassName, numOfNestedReplies = param.numOfNestedReplies, numOfReplies = param.numOfReplies;
    var ref;
    var t = (0,es/* useTranslation */.$G)().t;
    var ref1 = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref1.community, currentUser = ref1.currentUser;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var router = (0,next_router.useRouter)();
    var commentId = router && router.query && router.query.comment;
    var replyId;
    var ref2 = (0,useQuery/* useQuery */.a)(Replies_queries/* REPLY_DEPTH_QUERY */._j, {
        variables: {
            communityId: community.id,
            id: commentId
        },
        skip: !commentId
    }), data = ref2.data, loading = ref2.loading;
    var reply = data === null || data === void 0 ? void 0 : (ref = data.community) === null || ref === void 0 ? void 0 : ref.reply;
    if ((reply === null || reply === void 0 ? void 0 : reply.depth) === 2) {
        var ref3;
        // We have been linked to a reply!
        commentId = reply === null || reply === void 0 ? void 0 : (ref3 = reply.parentPost) === null || ref3 === void 0 ? void 0 : ref3.id;
        replyId = reply === null || reply === void 0 ? void 0 : reply.id;
    }
    if (commentId) {
        if (!CommentListSingular) {
            CommentListSingular = dynamic_default()(function() {
                return Promise.all(/* import() */[__webpack_require__.e(5290), __webpack_require__.e(7859), __webpack_require__.e(3852), __webpack_require__.e(5154), __webpack_require__.e(3173), __webpack_require__.e(5868)]).then(__webpack_require__.bind(__webpack_require__, 95868));
            }, {
                loadableGenerated: {
                    webpack: function() {
                        return [
                            /*require.resolve*/(95868)
                        ];
                    }
                },
                loading: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {
                        accessibilityLabel: t("common-loading", "Loading")
                    });
                }
            });
        }
    } else if (!CommentList) {
        CommentList = dynamic_default()(function() {
            return Promise.all(/* import() */[__webpack_require__.e(5290), __webpack_require__.e(7859), __webpack_require__.e(3852), __webpack_require__.e(5154), __webpack_require__.e(3173), __webpack_require__.e(478)]).then(__webpack_require__.bind(__webpack_require__, 478));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(478)
                    ];
                }
            },
            loading: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {
                    accessibilityLabel: t("common-loading", "Loading")
                });
            }
        });
    }
    if (!AddCommentModal) {
        AddCommentModal = dynamic_default()(function() {
            return Promise.all(/* import() */[__webpack_require__.e(5290), __webpack_require__.e(7859), __webpack_require__.e(3852), __webpack_require__.e(6635)]).then(__webpack_require__.bind(__webpack_require__, 26635));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(26635)
                    ];
                }
            },
            loading: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {
                    accessibilityLabel: t("common-loading", "Loading")
                });
            }
        });
    }
    if (!AddCommentContainer) {
        AddCommentContainer = dynamic_default()(function() {
            return Promise.all(/* import() */[__webpack_require__.e(5290), __webpack_require__.e(5154)]).then(__webpack_require__.bind(__webpack_require__, 55154));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(55154)
                    ];
                }
            },
            loading: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {
                    accessibilityLabel: t("common-loading", "Loading")
                });
            }
        });
    }
    if (!MentionsTextArea) {
        MentionsTextArea = dynamic_default()(function() {
            return Promise.all(/* import() */[__webpack_require__.e(5290), __webpack_require__.e(7859), __webpack_require__.e(3852)]).then(__webpack_require__.bind(__webpack_require__, 93852));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(93852)
                    ];
                }
            },
            loading: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {
                    accessibilityLabel: t("common-loading", "Loading")
                });
            }
        });
    }
    var commentList;
    if (commentId) {
        commentList = /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentListSingular, {
            commentId: commentId,
            communityWrapperRef: communityWrapperRef,
            lastCommentRef: lastCommentRef,
            parentPostId: post.id,
            parentPostRef: postRef,
            replyId: replyId,
            t: t
        });
    } else {
        commentList = /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList, {
            communityWrapperRef: communityWrapperRef,
            lastCommentRef: lastCommentRef,
            numOfNestedReplies: numOfNestedReplies,
            numOfReplies: numOfReplies,
            parentPostId: post.id,
            parentPostRef: postRef,
            t: t,
            onPostChange: onPostChange
        });
    }
    var relevantMentions = (author === null || author === void 0 ? void 0 : author.id) !== currentUser.id ? [
        {
            id: author === null || author === void 0 ? void 0 : author.id,
            avatarUrl: author === null || author === void 0 ? void 0 : author.avatarUrl,
            display: author === null || author === void 0 ? void 0 : author.fullName
        }, 
    ] : [];
    var renderButtonForMobile = function(openCommentModal, value) {
        var displayValue = (0,mentions/* makeMentionsUserFriendly */.d1)(value);
        var placeholderValue = t("Type @ to mention another member in your comment");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: CommentSection_cx("post-comment", {
                "has-value": !!value
            }),
            type: "button",
            onClick: openCommentModal,
            children: displayValue || placeholderValue
        });
    };
    var getCommentBox = function(inputProps) {
        if (width > constants/* BREAKPOINT_MD */.GI) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableTextArea/* default */.Z, (0,_object_spread/* default */.Z)({
                id: constants/* COMMENT_FORM_ID */.dp,
                label: t("components-post-add_comment", "Add comment..."),
                labelClass: "sr-only",
                mentionsComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(MentionsTextArea, {
                    additionalClassName: additionalClassName,
                    id: constants/* COMMENT_FORM_ID */.dp,
                    isModal: inputProps.isModal,
                    isPostForm: inputProps.isPostForm,
                    placeholder: t("Type @ to mention another member in your comment"),
                    relevantMentions: relevantMentions,
                    textAreaClassName: "mentions__text-area",
                    value: inputProps.value,
                    onChange: inputProps.handleMentionsChange
                }),
                parentPostRef: postRef,
                s3UploadPath: community.s3UploadPath,
                isAttachmentButtonsEnabled: true,
                isAttachmentRenderedInPortal: true
            }, inputProps));
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCommentModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            additionalClassName: "add-comment__modal",
            relevantMentions: relevantMentions
        }, inputProps), {
            renderButton: renderButtonForMobile
        }));
    };
    var commentInput = function(inputProps, user) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: CommentSection_cx("comment-input__wrapper"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* default */.Z, {
                    avatarUrl: user.avatarUrl,
                    className: CommentSection_cx("comment-input__avatar-container"),
                    size: "sm",
                    srcSet: "".concat(user.avatarUrl, "?width=40 1x, ").concat(user.avatarUrl, "?width=40&dpr=2 2x, ").concat(user.avatarUrl, "?width=40&dpr=3 3x"),
                    userId: user.id,
                    username: user.fullName,
                    shouldOpenProfile: true
                }),
                getCommentBox(inputProps)
            ]
        });
    };
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {
            accessibilityLabel: t("common-loading", "Loading")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: CommentSection_cx("comment-container"),
        "data-qa": "comment-container",
        children: [
            commentList,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCommentContainer, {
                communityWrapperRef: communityWrapperRef,
                lastCommentRef: lastCommentRef,
                parentPostId: post.id,
                renderChildren: commentInput,
                t: t,
                onCommentSubmitted: onCommentSubmitted
            })
        ]
    });
};
/* harmony default export */ var components_CommentSection = (CommentSection);

;// CONCATENATED MODULE: ./components/Post/Post.tsx























var Post_cx = bind_default().bind((Post_module_default()));
var Post = function(param) {
    var content = param.content, mentionedUsers = param.mentionedUsers, author = param.author, post = param.post, time = param.time, t = param.t, refetchPostList = param.refetchPostList, totalCommentCount = param.totalCommentCount, postReactionCount = param.postReactionCount, _shouldShowTagOnPost = param.shouldShowTagOnPost, shouldShowTagOnPost = _shouldShowTagOnPost === void 0 ? false : _shouldShowTagOnPost, onPostChange = param.onPostChange, handleDeletePost = param.handleDeletePost, handleEditPost = param.handleEditPost, trackPostEvent = param.trackPostEvent;
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref4.community, currentUser = ref4.currentUser, featureFlags = ref4.featureFlags;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isMobile = width < constants/* BREAKPOINT_MD */.GI;
    var ref5 = (0,react.useState)(((content === null || content === void 0 ? void 0 : content.length) || 0) > 480), shouldClampContent = ref5[0], setShouldClampContent = ref5[1];
    var commentsInFeedEnabled = featureFlags[constants_featureFlags/* features.COMMENTS_IN_FEED */.R.COMMENTS_IN_FEED];
    var firstAttachment = post === null || post === void 0 ? void 0 : (ref = post.postAttachments) === null || ref === void 0 ? void 0 : ref[0];
    var refetchQueries = [
        {
            query: queries/* POST_LIST_QUERY */.c,
            variables: {
                communityId: community.id,
                numOfPosts: constants/* POSTS_PER_PAGE */.DB,
                filter: {
                    following: true
                },
                postOrderField: undefined,
                numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
            }
        }, 
    ];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations/* UNFOLLOW_POST_MUTATION */.JB, {
        refetchQueries: refetchQueries
    }), 2), unfollowPost = ref6[0], ref7 = ref6[1], unfollowLoading = ref7.loading;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations/* FOLLOW_POST_MUTATION */.ZH, {
        refetchQueries: refetchQueries
    }), 2), followPost = ref8[0], ref9 = ref8[1], followLoading = ref9.loading;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations/* PIN_POST_MUTATION */.O7), 2), pinPost = ref10[0], ref11 = ref10[1], pinLoading = ref11.loading;
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations/* UNPIN_POST_MUTATION */.Nw), 2), unpinPost = ref12[0], ref13 = ref12[1], unpinLoading = ref13.loading;
    var goToPost = function() {
        (0,routerHelpers/* goToPostPage */.YY)(router, community.id, post.id, true, true);
    };
    var currentUserIsModerator = (0,userHelpers/* isModerator */.vJ)(currentUser.roles);
    var userCanEditPost = currentUserIsModerator || currentUser.id && currentUser.id === (author === null || author === void 0 ? void 0 : author.id);
    var postRef = react.useRef(null);
    var creationDateTime = (0,dateHelpers/* relativeFormattedDateTime */.f6)(time, currentUser === null || currentUser === void 0 ? void 0 : currentUser.locale, t);
    var postActionsList = [];
    if (post.isFollowing && !unfollowLoading) {
        postActionsList.push({
            name: "unfollow",
            text: "".concat(t("Unfollow")),
            onClick: function() {
                unfollowPost({
                    variables: {
                        id: post.id,
                        numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
                    }
                }).then(function() {
                    onPostChange === null || onPostChange === void 0 ? void 0 : onPostChange();
                    trackPostEvent(trackingEvents/* default.UNFOLLOW */.ZP.UNFOLLOW);
                });
            }
        });
    } else if (!followLoading) {
        postActionsList.push({
            name: "follow",
            text: t("Follow"),
            onClick: function() {
                followPost({
                    variables: {
                        id: post.id,
                        numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
                    }
                }).then(function() {
                    onPostChange === null || onPostChange === void 0 ? void 0 : onPostChange();
                    trackPostEvent(trackingEvents/* default.FOLLOW */.ZP.FOLLOW);
                });
            }
        });
    }
    if (userCanEditPost) {
        postActionsList.push({
            name: "edit",
            text: t("common-edit", "Edit"),
            onClick: handleEditPost
        });
    }
    if (currentUserIsModerator) {
        if (post.pinnedAt && !unpinLoading) {
            postActionsList.push({
                name: "unpin",
                text: t("Unpin"),
                onClick: function() {
                    return unpinPost({
                        variables: {
                            id: post.id,
                            numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
                        }
                    }).then(function() {
                        onPostChange === null || onPostChange === void 0 ? void 0 : onPostChange();
                        trackPostEvent(trackingEvents/* default.UNPIN */.ZP.UNPIN);
                        refetchPostList === null || refetchPostList === void 0 ? void 0 : refetchPostList({
                            shouldShowLoading: true
                        });
                    });
                }
            });
        } else if (!pinLoading) {
            postActionsList.push({
                name: "pin",
                text: t("Pin"),
                onClick: function() {
                    return pinPost({
                        variables: {
                            id: post.id,
                            numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
                        }
                    }).then(function() {
                        onPostChange === null || onPostChange === void 0 ? void 0 : onPostChange();
                        trackPostEvent(trackingEvents/* default.PIN */.ZP.PIN);
                        refetchPostList === null || refetchPostList === void 0 ? void 0 : refetchPostList({
                            shouldShowLoading: true
                        });
                    });
                }
            });
        }
        postActionsList.push({
            name: "delete",
            text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: Post_cx("post__detail-action"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        className: Post_cx("post__detail-action__icon"),
                        name: "trash-can"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("Delete post")
                    })
                ]
            }),
            title: t("Delete post"),
            onClick: handleDeletePost,
            type: InlineActions_constants/* DANGER_TYPE */.Z
        });
    }
    var hasAttachment = post.postAttachments && post.postAttachments[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: Post_cx("post"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "aria-label": "".concat(t("Read full post"), ": ").concat(post.title),
            className: Post_cx("post__container"),
            ref: postRef,
            role: "button",
            tabIndex: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: Post_cx("post__detail", {
                    "is-spaces-enabled": shouldShowTagOnPost
                }),
                id: post.id,
                role: "article",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: Post_cx("post__body", {
                            "is-spaces-enabled": shouldShowTagOnPost
                        }),
                        onClick: goToPost,
                        onKeyPress: function(e) {
                            if (e.key !== "Enter" && e.key !== " ") {
                                goToPost();
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostHeader/* default */.Z, {
                                author: author,
                                creationDateTime: creationDateTime || "",
                                editedAt: post.editedAt,
                                isFollowing: post.isFollowing,
                                isMobile: isMobile,
                                pinnedAt: post.pinnedAt,
                                postActionsList: postActionsList,
                                title: post.title || "",
                                showFollowingTag: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostContent/* default */.Z, {
                                content: content,
                                firstAttachment: firstAttachment,
                                hasAttachment: !!hasAttachment,
                                isPostPage: false,
                                mentionedUsers: mentionedUsers,
                                setShouldClampContent: function(shouldClamp) {
                                    setShouldClampContent(shouldClamp);
                                },
                                shouldClampContent: shouldClampContent,
                                t: t,
                                shouldScroll: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PostFooter, {
                        communityId: community.id,
                        goToPost: goToPost,
                        hasReacted: post.hasReacted,
                        post: post,
                        postReactionCount: postReactionCount,
                        showSpaceTag: shouldShowTagOnPost,
                        spaceIconName: ((ref1 = post.communitySpace) === null || ref1 === void 0 ? void 0 : ref1.iconName) || "",
                        spaceId: ((ref2 = post.communitySpace) === null || ref2 === void 0 ? void 0 : ref2.id) || "",
                        spaceName: ((ref3 = post.communitySpace) === null || ref3 === void 0 ? void 0 : ref3.name) || "",
                        totalCommentCount: totalCommentCount
                    }),
                    commentsInFeedEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CommentSection, {
                        additionalClassName: "post__feed",
                        author: author,
                        numOfNestedReplies: constants/* FEED_REPLY_COUNT */.gu,
                        numOfReplies: constants/* FEED_COMMENT_COUNT */.x8,
                        post: post,
                        postRef: postRef
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Post_Post = (Post);

;// CONCATENATED MODULE: ./components/Post/PostPagePost.tsx


/* PostPagePost - The specific Post that appears on the post details page */ 



















var PostPagePost_cx = bind_default().bind((Post_module_default()));
var PostPagePost = function(param) {
    var _additionalClassName = param.additionalClassName, additionalClassName = _additionalClassName === void 0 ? "" : _additionalClassName, content = param.content, mentionedUsers = param.mentionedUsers, author = param.author, post = param.post, time = param.time, t = param.t, refetchPostList = param.refetchPostList, totalCommentCount = param.totalCommentCount, postReactionCount = param.postReactionCount, _lastCommentRef = param.lastCommentRef, lastCommentRef = _lastCommentRef === void 0 ? {} : _lastCommentRef, _communityWrapperRef = param.communityWrapperRef, communityWrapperRef = _communityWrapperRef === void 0 ? {} : _communityWrapperRef, _shouldShowTagOnPost = param.shouldShowTagOnPost, shouldShowTagOnPost = _shouldShowTagOnPost === void 0 ? false : _shouldShowTagOnPost, onPostChange = param.onPostChange, handleDeletePost = param.handleDeletePost, handleEditPost = param.handleEditPost, trackPostEvent = param.trackPostEvent;
    var ref;
    var ref1 = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref1.community, currentUser = ref1.currentUser;
    var firstAttachment = post === null || post === void 0 ? void 0 : (ref = post.postAttachments) === null || ref === void 0 ? void 0 : ref[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations/* PIN_POST_MUTATION */.O7), 2), pinPost = ref2[0], ref3 = ref2[1], pinLoading = ref3.loading;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations/* UNPIN_POST_MUTATION */.Nw), 2), unpinPost = ref4[0], ref5 = ref4[1], unpinLoading = ref5.loading;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isMobile = width < constants/* BREAKPOINT_MD */.GI;
    var ref6 = (0,react.useState)(((content === null || content === void 0 ? void 0 : content.length) || 0) > 480), shouldClampContent = ref6[0], setShouldClampContent = ref6[1];
    var router = (0,next_router.useRouter)();
    var commentIdFromURL = router && router.query && router.query.comment;
    var goToPost = function() {
        (0,routerHelpers/* goToPostPage */.YY)(router, community.id, post.id, true, true);
    };
    var currentUserIsModerator = (0,userHelpers/* isModerator */.vJ)(currentUser.roles);
    var userCanEditPost = currentUserIsModerator || currentUser.id && currentUser.id === (author === null || author === void 0 ? void 0 : author.id);
    var postRef = react.useRef(null);
    var creationDateTime = (0,dateHelpers/* relativeFormattedDateTime */.f6)(time, currentUser === null || currentUser === void 0 ? void 0 : currentUser.locale, t);
    var onCommentSubmitted = function() {
        onPostChange === null || onPostChange === void 0 ? void 0 : onPostChange();
        if (commentIdFromURL) {
            goToPost();
        }
    };
    var postActionsList = [];
    if (userCanEditPost) {
        postActionsList.push({
            name: "edit",
            text: t("common-edit", "Edit"),
            onClick: handleEditPost
        });
    }
    if (currentUserIsModerator) {
        if (post.pinnedAt && !unpinLoading) {
            postActionsList.push({
                name: "unpin",
                text: t("Unpin"),
                onClick: function() {
                    return unpinPost({
                        variables: {
                            id: post.id,
                            numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
                        }
                    }).then(function() {
                        onPostChange === null || onPostChange === void 0 ? void 0 : onPostChange();
                        trackPostEvent(trackingEvents/* default.UNPIN */.ZP.UNPIN);
                        refetchPostList === null || refetchPostList === void 0 ? void 0 : refetchPostList({
                            shouldShowLoading: true
                        });
                    });
                }
            });
        } else if (!pinLoading) {
            postActionsList.push({
                name: "pin",
                text: t("Pin"),
                onClick: function() {
                    return pinPost({
                        variables: {
                            id: post.id,
                            numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
                        }
                    }).then(function() {
                        onPostChange === null || onPostChange === void 0 ? void 0 : onPostChange();
                        trackPostEvent(trackingEvents/* default.PIN */.ZP.PIN);
                        refetchPostList === null || refetchPostList === void 0 ? void 0 : refetchPostList({
                            shouldShowLoading: true
                        });
                    });
                }
            });
        }
        postActionsList.push({
            name: "delete",
            text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: PostPagePost_cx("post__detail-action"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        className: PostPagePost_cx("post__detail-action__icon"),
                        name: "trash-can"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("Delete post")
                    })
                ]
            }),
            title: t("Delete post"),
            onClick: handleDeletePost,
            type: InlineActions_constants/* DANGER_TYPE */.Z
        });
    }
    var hasAttachment = post.postAttachments && post.postAttachments[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: PostPagePost_cx("post"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: PostPagePost_cx("post__container", "post__container--full"),
            ref: postRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: PostPagePost_cx("post__detail", {
                    "is-spaces-enabled": shouldShowTagOnPost
                }),
                id: post.id,
                role: "article",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: PostPagePost_cx("post__body", {
                            "is-spaces-enabled": shouldShowTagOnPost
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostHeader/* default */.Z, {
                                author: author,
                                creationDateTime: creationDateTime || "",
                                editedAt: post.editedAt,
                                isFollowing: post.isFollowing,
                                isMobile: isMobile,
                                pinnedAt: post.pinnedAt,
                                postActionsList: postActionsList,
                                showFollowingTag: false,
                                title: post.title || ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostContent/* default */.Z, {
                                content: content,
                                firstAttachment: firstAttachment,
                                hasAttachment: !!hasAttachment,
                                isPostPage: false,
                                mentionedUsers: mentionedUsers,
                                setShouldClampContent: function(shouldClamp) {
                                    setShouldClampContent(shouldClamp);
                                },
                                shouldClampContent: shouldClampContent,
                                shouldScroll: false,
                                t: t
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: PostPagePost_cx("post__info"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactionButton/* default */.Z, {
                                hasReacted: post.hasReacted,
                                id: post.id,
                                isReactingTo: "post",
                                postReactionCount: postReactionCount,
                                reactionType: constants/* REACTION_TYPES.LIKE_POST */.B0.LIKE_POST,
                                reactors: (0,reactionHelpers/* getReactors */.U)(post),
                                t: t
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: PostPagePost_cx("total-comments"),
                                "data-qa": "main-comments_text",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        name: "discussions"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("{{count}} comment", {
                                            count: totalCommentCount
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: PostPagePost_cx("post__separator")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CommentSection, {
                        additionalClassName: additionalClassName || "",
                        author: author,
                        communityWrapperRef: communityWrapperRef,
                        lastCommentRef: lastCommentRef,
                        post: post,
                        postRef: postRef,
                        onCommentSubmitted: onCommentSubmitted
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Post_PostPagePost = (PostPagePost);

// EXTERNAL MODULE: ./node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(63659);
// EXTERNAL MODULE: ./utils/toastHelpers.ts
var toastHelpers = __webpack_require__(55049);
// EXTERNAL MODULE: ./helpers/postHelpers.ts
var postHelpers = __webpack_require__(68642);
// EXTERNAL MODULE: ./utils/rawId.ts
var rawId = __webpack_require__(93593);
;// CONCATENATED MODULE: ./components/PostContainer/PostContainer.tsx



















var EditPostModal;
var PostContainer = function(param) {
    var additionalClassName = param.additionalClassName, communityWrapperRef = param.communityWrapperRef, lastCommentRef = param.lastCommentRef, content = param.content, mentionedUsers = param.mentionedUsers, author = param.author, post = param.post, t = param.t, refetchPostList = param.refetchPostList, _isPostPage = param.isPostPage, isPostPage = _isPostPage === void 0 ? false : _isPostPage, goToPostListPage = param.goToPostListPage, _shouldShowTagOnPost = param.shouldShowTagOnPost, shouldShowTagOnPost = _shouldShowTagOnPost === void 0 ? false : _shouldShowTagOnPost, onPostChange = param.onPostChange;
    var ref;
    var ref1 = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref1.community, currentUser = ref1.currentUser, trackEvent = ref1.trackEvent;
    var currentUserIsModerator = (0,userHelpers/* isModerator */.vJ)(currentUser.roles);
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isMobile = width < constants/* BREAKPOINT_MD */.GI;
    var firstAttachment = post === null || post === void 0 ? void 0 : (ref = post.postAttachments) === null || ref === void 0 ? void 0 : ref[0];
    var ref2 = (0,react.useState)(false), isOpen = ref2[0], setIsOpen = ref2[1];
    var ref3 = (0,react.useState)(false), isEditModalOpen = ref3[0], setIsEditModalOpen = ref3[1];
    var trackPostEvent = function(event) {
        var _obj;
        return trackEvent(event, (_obj = {}, (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.ATTACHMENT */.Ku.ATTACHMENT, firstAttachment === null || firstAttachment === void 0 ? void 0 : firstAttachment.attachmentType), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.PINNED_POST */.Ku.PINNED_POST, !!post.pinnedAt), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.POST_ID */.Ku.POST_ID, (0,rawId/* rawId */.b)(post.id)), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.POST_ID_ENCODED */.Ku.POST_ID_ENCODED, post.id), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.POST_TYPE */.Ku.POST_TYPE, constants/* EVENT_POST_TYPES.POST */.Aj.POST), _obj));
    };
    // modal actions
    var handleDeletePost = function(event) {
        document.body.style.overflow = "hidden";
        setIsOpen(true);
        if (event) event.stopPropagation();
    };
    var closeDeletePostModal = function() {
        document.body.style.overflow = "visible";
        setIsOpen(false);
    };
    var handleEditPost = function(event) {
        document.body.style.overflow = "hidden";
        setIsEditModalOpen(true);
        if (event) event.stopPropagation();
    };
    var closeEditPostModal = function() {
        document.body.style.overflow = "visible";
        setIsEditModalOpen(false);
    };
    var handleConfirmDelete = function(mutation) {
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, deletePostData, deletePostError, userErrors;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        _ctx.next = 4;
                        return mutation({
                            variables: {
                                id: post.id
                            },
                            refetchQueries: isPostPage ? [] : [
                                "PostList",
                                "CommunitySpace"
                            ],
                            update: function update() {
                                closeDeletePostModal();
                            }
                        });
                    case 4:
                        ref1 = _ctx.sent;
                        deletePostData = ref1.data;
                        deletePostError = ref1.errors;
                        trackPostEvent(trackingEvents/* default.DELETE_POST */.ZP.DELETE_POST);
                        userErrors = deletePostData === null || deletePostData === void 0 ? void 0 : (ref = deletePostData.deletePost) === null || ref === void 0 ? void 0 : ref.userErrors;
                        if (!(userErrors === null || userErrors === void 0 ? void 0 : userErrors.length) && !(deletePostError === null || deletePostError === void 0 ? void 0 : deletePostError.length)) {
                            toaster_a57afb61.t.notice(t(constants/* SUCCESS_TOAST.DELETE_POST */.Gy.DELETE_POST));
                        } else {
                            (0,toastHelpers/* genericToastAlert */.d9)();
                        }
                        onPostChange === null || onPostChange === void 0 ? void 0 : onPostChange();
                        if (isPostPage) {
                            goToPostListPage === null || goToPostListPage === void 0 ? void 0 : goToPostListPage();
                        }
                        _ctx.next = 17;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,toastHelpers/* genericToastAlert */.d9)();
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    14
                ]
            ]);
        }));
    };
    // modal dynamic renders
    var renderEditPostModal = function() {
        if (!EditPostModal) {
            EditPostModal = dynamic_default()(function() {
                return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(76), __webpack_require__.e(5290), __webpack_require__.e(7859), __webpack_require__.e(3760), __webpack_require__.e(4739), __webpack_require__.e(3852), __webpack_require__.e(1475), __webpack_require__.e(9968)]).then(__webpack_require__.bind(__webpack_require__, 40841));
            }, {
                loadableGenerated: {
                    webpack: function() {
                        return [
                            /*require.resolve*/(40841)
                        ];
                    }
                },
                loading: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {
                        accessibilityLabel: t("common-loading", "Loading")
                    });
                }
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EditPostModal, {
            closeModal: closeEditPostModal,
            communityId: community.id,
            content: content,
            hasAutoFocus: isMobile,
            post: post,
            primaryColor: community.primaryColor,
            s3UploadPath: community.s3UploadPath,
            trackEvent: trackEvent
        });
    };
    var renderConfirmDeleteModal = function(mutate, loading) {
        var ConfirmDeleteModal = dynamic_default()(function() {
            return __webpack_require__.e(/* import() */ 6498).then(__webpack_require__.bind(__webpack_require__, 6498));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(6498)
                    ];
                }
            }
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDeleteModal, {
                closeAction: closeDeletePostModal,
                confirmDeleteBody: t("components-post-confirm_delete_post", "Are you sure you want to delete this post? You cannot undo this action."),
                confirmDeleteTitle: t("Delete post"),
                deleteAction: handleConfirmDelete(mutate),
                isConfirmModalOpen: isOpen,
                isLoading: loading
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isPostPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_PostPagePost, {
                additionalClassName: additionalClassName,
                author: author,
                communityWrapperRef: communityWrapperRef,
                content: content,
                handleDeletePost: handleDeletePost,
                handleEditPost: handleEditPost,
                lastCommentRef: lastCommentRef,
                mentionedUsers: mentionedUsers,
                post: post,
                postReactionCount: post.postReactions ? post.postReactions.totalCount : 0,
                refetchPostList: refetchPostList,
                shouldShowTagOnPost: shouldShowTagOnPost,
                t: t,
                time: post.createdAt,
                totalCommentCount: (0,postHelpers/* getTotalNumberOfReplies */.E)(post),
                trackPostEvent: trackPostEvent
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_Post, {
                author: author,
                content: content,
                handleDeletePost: handleDeletePost,
                handleEditPost: handleEditPost,
                mentionedUsers: mentionedUsers,
                post: post,
                postReactionCount: post.postReactions ? post.postReactions.totalCount : 0,
                refetchPostList: refetchPostList,
                shouldShowTagOnPost: shouldShowTagOnPost,
                t: t,
                time: post.createdAt,
                totalCommentCount: (0,postHelpers/* getTotalNumberOfReplies */.E)(post),
                trackPostEvent: trackPostEvent
            }),
            isEditModalOpen && renderEditPostModal(),
            currentUserIsModerator && isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Mutation/* Mutation */.m, {
                mutation: mutations/* DELETE_POST_MUTATION */.cz,
                children: function(mutate, param) {
                    var loading = param.loading;
                    return renderConfirmDeleteModal(mutate, loading);
                }
            })
        ]
    });
};
/* harmony default export */ var PostContainer_PostContainer = (PostContainer);


/***/ }),

/***/ 44215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ReactionButton_ReactionButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./utils/rawId.ts
var rawId = __webpack_require__(93593);
// EXTERNAL MODULE: ./schema/Replies/mutations.ts
var mutations = __webpack_require__(752);
// EXTERNAL MODULE: ./schema/Post/mutations.ts
var Post_mutations = __webpack_require__(74266);
// EXTERNAL MODULE: ./utils/toastHelpers.ts
var toastHelpers = __webpack_require__(55049);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./helpers/reactionHelpers.ts
var reactionHelpers = __webpack_require__(72579);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
;// CONCATENATED MODULE: ./components/ReactionButton/helpers.ts
var getScreenReaderText = function(hasReacted, reactionCount, isReactingTo, t) {
    switch(isReactingTo){
        case "comment":
            return hasReacted ? "".concat(t("components-reactionButton-remove_heart_from_comment_sr_text", "You reacted with a heart to this comment. Click to remove the reaction."), " ").concat(getTotalNumberOfReactionsString(reactionCount, t)) : "".concat(t("components-reactionButton-react_with_heart_to_comment_sr_text", "You have not reacted to this comment. Click to react with a heart."), " ").concat(getTotalNumberOfReactionsString(reactionCount, t));
        default:
            return hasReacted ? "".concat(t("components-reactionButton-remove_heart_from_post_sr_text", "You reacted with a heart to this post. Click to remove the reaction."), " ").concat(getTotalNumberOfReactionsString(reactionCount, t)) : "".concat(t("components-reactionButton-react_with_heart_to_post_sr_text", "You have not reacted to this post. Click to react with a heart."), " ").concat(getTotalNumberOfReactionsString(reactionCount, t));
    }
};
function getTotalNumberOfReactionsString(reactionCount, t) {
    return t("components-reactionButton-total_reactions_sr_text", "The total number of reactions for this item is {{reactionCount}}.", {
        reactionCount: reactionCount
    });
}

// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Tooltip-00b73669.js
var Tooltip_00b73669 = __webpack_require__(20021);
;// CONCATENATED MODULE: ./components/ReactionButton/ReactionHoverList.tsx




var ReactionHoverList = function(param) {
    var children = param.children, hasReacted = param.hasReacted, postReactionCount = param.postReactionCount, reactionsToShow = param.reactionsToShow, reactors = param.reactors, t = param.t;
    var currentUser = (0,CommunityContext/* useCommunityContext */.v1)().currentUser;
    var reactorList = reactors.slice();
    var isCurrentUserInList = currentUser && !!reactors.find(function(r) {
        return r.id === currentUser.id;
    });
    if (hasReacted && currentUser) {
        if (isCurrentUserInList) {
            // Need to remove their name and put You at the front
            reactorList = reactorList.filter(function(r) {
                return r.id !== currentUser.id;
            });
            reactorList.unshift({
                fullName: t("You")
            });
        } else {
            // Put You at the front, and pop someone off the back
            reactorList.unshift({
                fullName: t("You")
            });
            if (postReactionCount >= reactionsToShow) {
                reactorList.pop();
            }
        }
    }
    if (postReactionCount > reactionsToShow) {
        var hiddenReactors = postReactionCount - reactionsToShow;
        var plusMore = {
            fullName: t("+ {{nameCount}} more", {
                nameCount: hiddenReactors
            })
        };
        reactorList = reactorList.slice(0, reactionsToShow).concat(plusMore);
    }
    var reactorNames = reactorList.map(function(r) {
        return r.fullName;
    }).join(", ");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_00b73669.T, {
        enterDelay: 400,
        title: reactorNames,
        children: children
    });
};
/* harmony default export */ var ReactionButton_ReactionHoverList = (ReactionHoverList);

// EXTERNAL MODULE: ./components/ReactionButton/ReactionButton.module.scss
var ReactionButton_module = __webpack_require__(6950);
var ReactionButton_module_default = /*#__PURE__*/__webpack_require__.n(ReactionButton_module);
;// CONCATENATED MODULE: ./components/ReactionButton/ReactionButton.tsx





















var cx = bind_default().bind((ReactionButton_module_default()));
var ReactionButton = function(param) {
    var _appearance = param.appearance, appearance = _appearance === void 0 ? "knockout" : _appearance, hasReactedProp = param.hasReacted, id = param.id, isReactingTo = param.isReactingTo, _parentPostId = param.parentPostId, parentPostId = _parentPostId === void 0 ? "" : _parentPostId, _parentReplyId = param.parentReplyId, parentReplyId = _parentReplyId === void 0 ? "" : _parentReplyId, postReactionCount = param.postReactionCount, reactionType = param.reactionType, reactors = param.reactors, _size = param.size, size = _size === void 0 ? "small" : _size, t = param.t;
    var trackEvent = (0,CommunityContext/* useCommunityContext */.v1)().trackEvent;
    var ref = (0,react.useState)((0,reactionHelpers/* getIconName */.t)(reactionType, hasReactedProp)), iconName = ref[0], setIconName = ref[1];
    var ref1 = (0,react.useState)(postReactionCount), reactionCount = ref1[0], setReactionCount = ref1[1];
    var ref2 = (0,react.useState)(hasReactedProp), hasReacted = ref2[0], setHasReacted = ref2[1];
    var screenReaderText = getScreenReaderText(!!hasReacted, reactionCount, isReactingTo, t);
    (0,react.useEffect)(function() {
        setIconName((0,reactionHelpers/* getIconName */.t)(reactionType, hasReacted));
    }, [
        reactionType,
        hasReacted
    ]);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(Post_mutations/* TOGGLE_REACTION_ON_POST_MUTATION */.t3, {
        onError: toastHelpers/* genericToastAlert */.d9
    }), 2), toggleReactionOnPostMutation = ref3[0], ref4 = ref3[1], togglePostReactionLoading = ref4.loading;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations/* TOGGLE_REACTION_ON_REPLY_MUTATION */.Y3, {
        onError: toastHelpers/* genericToastAlert */.d9
    }), 2), toggleReactionOnReplyMutation = ref5[0], ref6 = ref5[1], toggleReplyReactionLoading = ref6.loading;
    var handleParentPostReactionClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, reactPostData, reactPostError, userErrors, _post, updatedHasReacted;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (togglePostReactionLoading) {
                            _ctx.next = 9;
                            break;
                        }
                        ;
                        _ctx.next = 4;
                        return toggleReactionOnPostMutation({
                            variables: {
                                id: id,
                                reactionType: reactionType,
                                numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
                            }
                        });
                    case 4:
                        ref1 = _ctx.sent;
                        reactPostData = ref1.data;
                        reactPostError = ref1.errors;
                        userErrors = reactPostData === null || reactPostData === void 0 ? void 0 : (ref = reactPostData.toggleReactionOnPost) === null || ref === void 0 ? void 0 : ref.userErrors;
                        if (!(userErrors === null || userErrors === void 0 ? void 0 : userErrors.length) && !(reactPostError === null || reactPostError === void 0 ? void 0 : reactPostError.length)) {
                            _post = reactPostData.toggleReactionOnPost.post, updatedHasReacted = _post.hasReacted;
                            trackReactEvent({
                                hasReacted: updatedHasReacted
                            });
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleParentPostReactionClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReplyReactionClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, reactReplyData, reactReplyError, userErrors, _reply, updatedHasReacted;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (toggleReplyReactionLoading) {
                            _ctx.next = 9;
                            break;
                        }
                        ;
                        _ctx.next = 4;
                        return toggleReactionOnReplyMutation({
                            variables: {
                                id: id,
                                reactionType: reactionType,
                                numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
                            }
                        });
                    case 4:
                        ref1 = _ctx.sent;
                        reactReplyData = ref1.data;
                        reactReplyError = ref1.errors;
                        userErrors = reactReplyData === null || reactReplyData === void 0 ? void 0 : (ref = reactReplyData.toggleReactionOnReply) === null || ref === void 0 ? void 0 : ref.userErrors;
                        if (!(userErrors === null || userErrors === void 0 ? void 0 : userErrors.length) && !(reactReplyError === null || reactReplyError === void 0 ? void 0 : reactReplyError.length)) {
                            _reply = reactReplyData.toggleReactionOnReply.reply, updatedHasReacted = _reply.hasReacted;
                            trackReactEvent({
                                hasReacted: updatedHasReacted
                            });
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleReplyReactionClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReactionClick = function(e) {
        e.stopPropagation();
        if (togglePostReactionLoading || toggleReplyReactionLoading) return;
        setReactionCount(hasReacted ? reactionCount - 1 : reactionCount + 1);
        setHasReacted(!hasReacted);
        if (!parentPostId && !parentReplyId) {
            handleParentPostReactionClick();
        } else {
            handleReplyReactionClick();
        }
    };
    var trackReactEvent = function(updatedInfo) {
        var postType = parentReplyId ? constants/* EVENT_POST_TYPES.REPLY */.Aj.REPLY : constants/* EVENT_POST_TYPES.COMMENT */.Aj.COMMENT;
        postType = parentPostId ? postType : constants/* EVENT_POST_TYPES.POST */.Aj.POST;
        var reactedAt = new Date();
        var _obj;
        trackEvent(trackingEvents/* default.POST_REACTED */.ZP.POST_REACTED, (_obj = {}, (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.POST_ID */.Ku.POST_ID, (0,rawId/* rawId */.b)(id)), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.POST_ID_ENCODED */.Ku.POST_ID_ENCODED, id), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.POST_TYPE */.Ku.POST_TYPE, postType), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.INTERACTION_TYPE */.Ku.INTERACTION_TYPE, updatedInfo.hasReacted ? "Added Reaction" : "Removed Reaction"), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.REACTION_TIMESTAMP */.Ku.REACTION_TIMESTAMP, reactedAt.toISOString()), _obj));
    };
    var reactionButton = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* ButtonWithIconLeft */.ej, {
        appearance: appearance,
        className: parentPostId ? cx("comment__reaction-button") : "",
        "data-qa": "reaction-button",
        size: size,
        onClick: handleReactionClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                name: iconName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                "aria-live": "polite",
                className: cx("sr-only"),
                children: screenReaderText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                "aria-hidden": true,
                children: reactionCount
            })
        ]
    });
    var isLoading = togglePostReactionLoading || toggleReplyReactionLoading;
    if (reactors && reactionCount && !isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactionButton_ReactionHoverList, {
            hasReacted: !!hasReacted,
            postReactionCount: reactionCount,
            reactionsToShow: constants/* NUMBER_OF_REACTIONS */.ed,
            reactors: reactors,
            t: t,
            children: reactionButton
        });
    }
    return reactionButton;
};
/* harmony default export */ var ReactionButton_ReactionButton = (ReactionButton);

;// CONCATENATED MODULE: ./components/ReactionButton/index.ts



/***/ }),

/***/ 72579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getReactors; },
/* harmony export */   "t": function() { return /* binding */ getIconName; }
/* harmony export */ });
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59830);

function getIconName() {
    var reactionType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .REACTION_TYPES.LIKE_POST */ .B0.LIKE_POST, hasReacted = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    switch(reactionType){
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .REACTION_TYPES.LIKE_POST */ .B0.LIKE_POST:
            return hasReacted ? utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .REACTION_ICONS.LIKE_POST_TRUE */ .iS.LIKE_POST_TRUE : utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .REACTION_ICONS.LIKE_POST_FALSE */ .iS.LIKE_POST_FALSE;
        default:
            return utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .REACTION_ICONS.LIKE_POST_FALSE */ .iS.LIKE_POST_FALSE;
    }
}
var getReactors = function(post) {
    var edges = post && post.postReactions && post.postReactions.edges;
    var usersWithNames = edges === null || edges === void 0 ? void 0 : edges.filter(function(edge) {
        var ref;
        var user = edge === null || edge === void 0 ? void 0 : (ref = edge.node) === null || ref === void 0 ? void 0 : ref.user;
        return (user === null || user === void 0 ? void 0 : user.id) != null && (user === null || user === void 0 ? void 0 : user.fullName) != null;
    });
    return Array.isArray(usersWithNames) ? usersWithNames.map(function(edge) {
        var ref;
        var user = edge === null || edge === void 0 ? void 0 : (ref = edge.node) === null || ref === void 0 ? void 0 : ref.user;
        return {
            id: (user === null || user === void 0 ? void 0 : user.id) || "",
            fullName: (user === null || user === void 0 ? void 0 : user.fullName) || ""
        };
    }) : [];
};


/***/ }),

/***/ 44586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Input_Input; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Label/index.ts + 1 modules
var Label = __webpack_require__(23185);
// EXTERNAL MODULE: ./koba/components/Input/Input.module.scss
var Input_module = __webpack_require__(69095);
var Input_module_default = /*#__PURE__*/__webpack_require__.n(Input_module);
;// CONCATENATED MODULE: ./koba/components/Input/Input.js













var cx = bind_default().bind((Input_module_default()));
var Input = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Input, Component);
    var _super = (0,_create_super/* default */.Z)(Input);
    function Input() {
        (0,_class_call_check/* default */.Z)(this, Input);
        var _this;
        _this = _super.apply(this, arguments);
        // eslint-disable-next-line react/state-in-constructor
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "state", {
            value: ""
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleValueFieldChange", function(e) {
            var _props = _this.props, handleChange = _props.handleChange, validator = _props.validator;
            var newValue = e.target.value;
            var isValid = true;
            if (validator && !validator(newValue)) {
                isValid = false;
            }
            if (isValid) {
                var ref;
                _this.setState({
                    value: newValue
                });
                if (handleChange) handleChange(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "sanitizeState", function(state) {
            var sanitizedState = {};
            Object.keys(state).forEach(function(key) {
                sanitizedState[key] = state[key].trim();
            });
            return sanitizedState;
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleKeyDown", function(e) {
            var handleKeyDown = _this.props.handleKeyDown;
            handleKeyDown(e, _this.sanitizeState(_this.state));
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleKeyPress", function(e) {
            var onEnter = _this.props.onEnter;
            if (e.key === "Enter" && onEnter !== null) {
                onEnter(e, _this.sanitizeState(_this.state));
            }
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(Input, [
        {
            // eslint-disable-next-line camelcase
            key: "UNSAFE_componentWillMount",
            value: function UNSAFE_componentWillMount() {
                var initValue = this.props.initValue;
                if (initValue !== "") {
                    this.setState({
                        value: initValue.toString()
                    });
                }
            }
        },
        {
            // eslint-disable-next-line camelcase
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                // Update the input state when you change the value from outside
                this.setState({
                    value: nextProps.initValue
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, ariaControls = _props.ariaControls, hasError = _props.hasError, id = _props.id, isDisabled = _props.isDisabled, name = _props.name, type = _props.type, placeholder = _props.placeholder, extraClasses = _props.extraClasses, extraProps = _props.extraProps, label = _props.label, handleBlur = _props.handleBlur, hasAutoFocus = _props.hasAutoFocus, hasNoGroup = _props.hasNoGroup, wrapperClass = _props.wrapperClass, formText = _props.formText;
                var value = this.state.value;
                var inputLabel = label;
                if (typeof label === "string") {
                    inputLabel = /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                        className: cx("input__label"),
                        htmlFor: id,
                        children: label
                    });
                }
                var inputClasses = cx("input__box--input", "form-control", extraClasses, {
                    error: hasError
                });
                var formTextClasses = cx("form-text", {
                    "error-message": hasError
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: cx("input__box", wrapperClass, {
                        "form-group": !hasNoGroup
                    }),
                    children: [
                        inputLabel,
                        type === "textarea" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread/* default */.Z)({
                            autoFocus: hasAutoFocus,
                            className: inputClasses,
                            "data-qa": "modal__text-area-".concat(name),
                            disabled: isDisabled,
                            id: id,
                            name: name,
                            placeholder: placeholder,
                            ref: function(node) {
                                _this.input = node;
                            },
                            value: value,
                            onBlur: handleBlur,
                            onChange: this.handleValueFieldChange,
                            onKeyDown: this.handleKeyDown,
                            onKeyPress: this.handleKeyPress
                        }, extraProps)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                            "aria-controls": ariaControls,
                            autoFocus: hasAutoFocus,
                            className: inputClasses,
                            "data-qa": "modal__input-".concat(name),
                            disabled: isDisabled,
                            id: id,
                            name: name,
                            placeholder: placeholder,
                            ref: function(node) {
                                _this.input = node;
                            },
                            type: type,
                            value: value,
                            onBlur: handleBlur,
                            onChange: this.handleValueFieldChange,
                            onKeyDown: this.handleKeyDown,
                            onKeyPress: this.handleKeyPress
                        }, extraProps)),
                        formText && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: formTextClasses,
                            children: formText
                        })
                    ]
                });
            }
        }
    ]);
    return Input;
}(react.Component);
Input.propTypes = {
    ariaControls: (prop_types_default()).string,
    extraClasses: (prop_types_default()).string,
    extraProps: (prop_types_default()).object,
    formText: (prop_types_default()).string,
    handleBlur: (prop_types_default()).func,
    handleChange: (prop_types_default()).func,
    handleKeyDown: (prop_types_default()).func,
    hasAutoFocus: (prop_types_default()).bool,
    hasClearButton: (prop_types_default()).bool,
    hasError: (prop_types_default()).bool,
    hasNoGroup: (prop_types_default()).bool,
    id: (prop_types_default()).string,
    initValue: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    isDisabled: (prop_types_default()).bool,
    label: (prop_types_default()).any,
    name: (prop_types_default()).string,
    placeholder: (prop_types_default()).string,
    type: (prop_types_default()).string,
    validator: (prop_types_default()).func,
    wrapperClass: (prop_types_default()).string,
    onEnter: (prop_types_default()).func
};
Input.defaultProps = {
    ariaControls: null,
    handleBlur: null,
    handleKeyDown: function() {},
    validator: function() {
        return true;
    },
    handleChange: null,
    hasClearButton: false,
    hasError: false,
    name: "",
    type: "text",
    initValue: "",
    isDisabled: false,
    placeholder: "",
    extraProps: {},
    extraClasses: "",
    label: null,
    id: null,
    onEnter: null,
    hasAutoFocus: false,
    hasNoGroup: false,
    wrapperClass: null,
    formText: null
};
/* harmony default export */ var Input_Input = (Input);

;// CONCATENATED MODULE: ./koba/components/Input/index.js



/***/ }),

/***/ 23185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Label_Label; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Label/Label.module.scss
var Label_module = __webpack_require__(82645);
var Label_module_default = /*#__PURE__*/__webpack_require__.n(Label_module);
;// CONCATENATED MODULE: ./koba/components/Label/Label.tsx








var cx = bind_default().bind((Label_module_default()));
var Label = function(_param) {
    var className = _param.className, children = _param.children, htmlFor = _param.htmlFor, attrs = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children",
        "htmlFor"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: cx("label", className),
        htmlFor: htmlFor
    }, attrs), {
        children: children
    }));
};
Label.propTypes = {
    children: (prop_types_default()).node.isRequired,
    className: (prop_types_default()).string,
    htmlFor: (prop_types_default()).string
};
Label.defaultProps = {
    className: "",
    htmlFor: ""
};
/* harmony default export */ var Label_Label = (Label);

;// CONCATENATED MODULE: ./koba/components/Label/index.ts



/***/ }),

/***/ 74266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hd": function() { return /* binding */ EDIT_POST_MUTATION; },
/* harmony export */   "JB": function() { return /* binding */ UNFOLLOW_POST_MUTATION; },
/* harmony export */   "Nw": function() { return /* binding */ UNPIN_POST_MUTATION; },
/* harmony export */   "O7": function() { return /* binding */ PIN_POST_MUTATION; },
/* harmony export */   "ZH": function() { return /* binding */ FOLLOW_POST_MUTATION; },
/* harmony export */   "cz": function() { return /* binding */ DELETE_POST_MUTATION; },
/* harmony export */   "dl": function() { return /* binding */ CREATE_POST_MUTATION; },
/* harmony export */   "t3": function() { return /* binding */ TOGGLE_REACTION_ON_POST_MUTATION; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75063);
/* harmony import */ var utils_queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57917);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreatePost(\n    $discussionableId: ID!\n    $title: String!\n    $content: String\n    $spaceId: ID\n    $postAttachment: PostAttachmentInput\n    $mentionedUserIds: [ID!]\n  ) {\n    createPost(\n      input: {\n        discussionableId: $discussionableId\n        title: $title\n        content: $content\n        communitySpaceId: $spaceId\n        postAttachmentInput: $postAttachment\n        mentionedUserIds: $mentionedUserIds\n      }\n    ) {\n      post {\n        id\n      }\n      userErrors {\n        code\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation EditPost($input: EditPostInput!, $numberOfReactions: Int!) {\n    editPost(input: $input) {\n      userErrors {\n        code\n        message\n      }\n      post {\n        ...PostFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation DeletePost($id: ID!) {\n    deletePost(input: { id: $id }) {\n      userErrors {\n        code\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation FollowPost($id: ID!, $numberOfReactions: Int!) {\n    followPost(input: { id: $id }) {\n      userErrors {\n        code\n        message\n      }\n      post {\n        ...PostFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation UnfollowPost($id: ID!, $numberOfReactions: Int!) {\n    unfollowPost(input: { id: $id }) {\n      userErrors {\n        code\n        message\n      }\n      post {\n        ...PostFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation PinPost($id: ID!, $numberOfReactions: Int!) {\n    pinPost(input: { id: $id }) {\n      userErrors {\n        code\n        message\n      }\n      post {\n        ...PostFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation UnpinPost($id: ID!, $numberOfReactions: Int!) {\n    unpinPost(input: { id: $id }) {\n      userErrors {\n        code\n        message\n      }\n      post {\n        ...PostFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation ToggleReactionOnPost(\n    $id: ID!\n    $reactionType: PostReactionType!\n    $numberOfReactions: Int!\n  ) {\n    toggleReactionOnPost(input: { id: $id, reactionType: $reactionType }) {\n      userErrors {\n        code\n        message\n      }\n      post {\n        ...PostFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var CREATE_POST_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject());
var EDIT_POST_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject1(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .POST_FRAGMENT */ .Tj);
var DELETE_POST_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject2());
var FOLLOW_POST_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject3(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .POST_FRAGMENT */ .Tj);
var UNFOLLOW_POST_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject4(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .POST_FRAGMENT */ .Tj);
var PIN_POST_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject5(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .POST_FRAGMENT */ .Tj);
var UNPIN_POST_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject6(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .POST_FRAGMENT */ .Tj);
var TOGGLE_REACTION_ON_POST_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject7(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .POST_FRAGMENT */ .Tj);


/***/ }),

/***/ 752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jx": function() { return /* binding */ FOLLOW_REPLY_MUTATION; },
/* harmony export */   "WQ": function() { return /* binding */ UNFOLLOW_REPLY_MUTATION; },
/* harmony export */   "WR": function() { return /* binding */ DELETE_REPLY_MUTATION; },
/* harmony export */   "Y3": function() { return /* binding */ TOGGLE_REACTION_ON_REPLY_MUTATION; },
/* harmony export */   "jn": function() { return /* binding */ EDIT_REPLY_MUTATION; },
/* harmony export */   "o4": function() { return /* binding */ CREATE_REPLY_MUTATION; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75063);
/* harmony import */ var _utils_queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57917);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateReply(\n    $discussionableId: ID!\n    $content: String\n    $parentPostId: ID\n    $parentReplyId: ID\n    $postAttachmentInput: PostAttachmentInput\n    $mentionedUserIds: [ID!]\n    $numberOfReactions: Int!\n  ) {\n    createReply(\n      input: {\n        discussionableId: $discussionableId\n        content: $content\n        parentPostId: $parentPostId\n        parentReplyId: $parentReplyId\n        postAttachmentInput: $postAttachmentInput\n        mentionedUserIds: $mentionedUserIds\n      }\n    ) {\n      userErrors {\n        code\n        message\n      }\n      reply {\n        ...ReplyFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation EditReply($input: EditReplyInput!, $numberOfReactions: Int!) {\n    editReply(input: $input) {\n      userErrors {\n        code\n        message\n      }\n      reply {\n        ...ReplyFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation DeleteReply($id: ID!) {\n    deleteReply(input: { id: $id }) {\n      userErrors {\n        code\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation ToggleReactionOnReply(\n    $id: ID!\n    $reactionType: PostReactionType!\n    $numberOfReactions: Int!\n  ) {\n    toggleReactionOnReply(input: { id: $id, reactionType: $reactionType }) {\n      userErrors {\n        code\n        message\n      }\n      reply {\n        ...ReplyFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation FollowReply($id: ID!, $numberOfReactions: Int!) {\n    followReply(input: { id: $id }) {\n      userErrors {\n        code\n        message\n      }\n      reply {\n        ...ReplyFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation UnfollowReply($id: ID!, $numberOfReactions: Int!) {\n    unfollowReply(input: { id: $id }) {\n      userErrors {\n        code\n        message\n      }\n      reply {\n        ...ReplyFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var CREATE_REPLY_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), _utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .REPLY_FRAGMENT */ .sN);
var EDIT_REPLY_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject1(), _utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .REPLY_FRAGMENT */ .sN);
var DELETE_REPLY_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject2());
var TOGGLE_REACTION_ON_REPLY_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject3(), _utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .REPLY_FRAGMENT */ .sN);
var FOLLOW_REPLY_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject4(), _utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .REPLY_FRAGMENT */ .sN);
var UNFOLLOW_REPLY_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject5(), _utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .REPLY_FRAGMENT */ .sN);


/***/ }),

/***/ 28865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FE": function() { return /* binding */ NESTED_REPLIES_QUERY; },
/* harmony export */   "Z4": function() { return /* binding */ REPLIES_QUERY; },
/* harmony export */   "_j": function() { return /* binding */ REPLY_DEPTH_QUERY; },
/* harmony export */   "yS": function() { return /* binding */ REPLY_QUERY; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75063);
/* harmony import */ var utils_queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57917);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  query Reply(\n    $communityId: ID!\n    $postId: ID!\n    $id: ID!\n    $startCursor: String\n    $numOfNestedReplies: Int\n    $numberOfReactions: Int!\n  ) {\n    community(id: $communityId) {\n      id\n      post(id: $postId) {\n        ...PostFields\n      }\n      reply(id: $id) {\n        ...ReplyFields\n        replies(\n          orderBy: { field: CREATED_AT, direction: ASC }\n          before: $startCursor\n          last: $numOfNestedReplies\n        ) @connection(key: "replies") {\n          edges {\n            cursor\n            node {\n              ...ReplyFields\n            }\n          }\n          pageInfo {\n            hasPreviousPage\n            hasNextPage\n            startCursor\n            endCursor\n          }\n          totalCount\n        }\n      }\n    }\n  }\n  ',
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  query Replies(\n    $communityId: ID!\n    $postId: ID!\n    $numOfReplies: Int\n    $numOfNestedReplies: Int\n    $startCursor: String\n    $numberOfReactions: Int!\n  ) {\n    community(id: $communityId) {\n      id\n      post(id: $postId) {\n        id\n        replies(\n          last: $numOfReplies\n          before: $startCursor\n          orderBy: { field: CREATED_AT, direction: ASC }\n        ) @connection(key: "replies") {\n          edges {\n            cursor\n            node {\n              ...ReplyEdgeFields\n            }\n          }\n          pageInfo {\n            hasPreviousPage\n            hasNextPage\n            startCursor\n            endCursor\n          }\n          totalCount\n        }\n      }\n    }\n  }\n  ',
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  query NestedReplies(\n    $communityId: ID!\n    $parentReplyId: ID!\n    $numOfReplies: Int\n    $startCursor: String\n    $numberOfReactions: Int!\n  ) {\n    community(id: $communityId) {\n      id\n      reply(id: $parentReplyId) {\n        id\n        replies(\n          last: $numOfReplies\n          before: $startCursor\n          orderBy: { field: CREATED_AT, direction: ASC }\n        ) @connection(key: "replies") {\n          edges {\n            cursor\n            node {\n              ...ReplyFields\n            }\n          }\n          pageInfo {\n            hasPreviousPage\n            hasNextPage\n            startCursor\n            endCursor\n          }\n          totalCount\n        }\n      }\n    }\n  }\n  ',
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query ReplyDepth($communityId: ID!, $id: ID!) {\n    community(id: $communityId) {\n      id\n      reply(id: $id) {\n        id\n        depth\n        parentPost {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var REPLY_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .REPLY_FRAGMENT */ .sN, utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .POST_FRAGMENT */ .Tj);
var REPLIES_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject1(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .REPLY_EDGE_FRAGMENT */ .MM);
var NESTED_REPLIES_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject2(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .REPLY_FRAGMENT */ .sN);
var REPLY_DEPTH_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject3());



/***/ }),

/***/ 90312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ parseLoomId; },
/* harmony export */   "q": function() { return /* binding */ isLoomUrl; }
/* harmony export */ });
/* harmony import */ var js_video_url_parser_lib_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24110);
/* harmony import */ var js_video_url_parser_lib_base__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_video_url_parser_lib_base__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var js_video_url_parser_lib_provider_loom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30750);
/* harmony import */ var js_video_url_parser_lib_provider_loom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(js_video_url_parser_lib_provider_loom__WEBPACK_IMPORTED_MODULE_1__);

// eslint-disable-next-line import/no-duplicates

var isLoomUrl = function(url) {
    var parseResult = js_video_url_parser_lib_base__WEBPACK_IMPORTED_MODULE_0___default().parse(url);
    return parseResult !== undefined && parseResult.provider === "loom";
};
var parseLoomId = function(url) {
    var ref;
    return ((ref = js_video_url_parser_lib_base__WEBPACK_IMPORTED_MODULE_0___default().parse(url)) === null || ref === void 0 ? void 0 : ref.id) || "";
};



/***/ }),

/***/ 31466:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"AttachmentButtons_sr-only--mobile__ITbGr","sr-only":"AttachmentButtons_sr-only__hyTiR","error-message":"AttachmentButtons_error-message__6wDCk","form-inline-edit":"AttachmentButtons_form-inline-edit__xnNIY","form-group":"AttachmentButtons_form-group__e9Tje","form-row":"AttachmentButtons_form-row__xRoA6","form-inline":"AttachmentButtons_form-inline__jDUxa","error":"AttachmentButtons_error__q04aZ","input-group-append":"AttachmentButtons_input-group-append__hRLFZ","input-group-currency":"AttachmentButtons_input-group-currency__9PUHU","form-control":"AttachmentButtons_form-control__kjaHf","custom-select":"AttachmentButtons_custom-select__Ri0AO","is-invalid":"AttachmentButtons_is-invalid__MiyeW","is-valid":"AttachmentButtons_is-valid__3rI1A","input-group":"AttachmentButtons_input-group__Ap2Qe","input-group-text":"AttachmentButtons_input-group-text__kTtsD","input-group-prepend":"AttachmentButtons_input-group-prepend__wwaUo","valid-feedback":"AttachmentButtons_valid-feedback__zpYH1","invalid-feedback":"AttachmentButtons_invalid-feedback__Ligcj","form-text":"AttachmentButtons_form-text__9YrO2","label":"AttachmentButtons_label__vCByQ","custom-control":"AttachmentButtons_custom-control__tAo11","custom-control-label":"AttachmentButtons_custom-control-label__iOjaK","custom-control-label--empty":"AttachmentButtons_custom-control-label--empty__tdMiu","custom-control-input":"AttachmentButtons_custom-control-input__e7DNj","attachment__buttons":"AttachmentButtons_attachment__buttons__vVYRY","attachment__buttons--icon-only":"AttachmentButtons_attachment__buttons--icon-only__gK6pC","attachment__mobile-input":"AttachmentButtons_attachment__mobile-input__JkCOo","attachment-input__container":"AttachmentButtons_attachment-input__container__cTCzw"};

/***/ }),

/***/ 94917:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"AttachmentFileInput_sr-only--mobile__OMPxf","sr-only":"AttachmentFileInput_sr-only__skLHY","error-message":"AttachmentFileInput_error-message__GbApT","form-inline-edit":"AttachmentFileInput_form-inline-edit__BQla5","form-group":"AttachmentFileInput_form-group__5W3GX","form-row":"AttachmentFileInput_form-row__CXf2T","form-inline":"AttachmentFileInput_form-inline___PBUJ","error":"AttachmentFileInput_error__mCyto","input-group-append":"AttachmentFileInput_input-group-append__A_sDy","input-group-currency":"AttachmentFileInput_input-group-currency__p_RpR","form-control":"AttachmentFileInput_form-control__j08WJ","custom-select":"AttachmentFileInput_custom-select__2NHGZ","is-invalid":"AttachmentFileInput_is-invalid__Wc4r0","is-valid":"AttachmentFileInput_is-valid__yq_Yd","input-group":"AttachmentFileInput_input-group__22Fq7","input-group-text":"AttachmentFileInput_input-group-text__DaEqo","input-group-prepend":"AttachmentFileInput_input-group-prepend__RkQFj","valid-feedback":"AttachmentFileInput_valid-feedback__XZcPx","invalid-feedback":"AttachmentFileInput_invalid-feedback__cFTKp","form-text":"AttachmentFileInput_form-text__JpDD1","label":"AttachmentFileInput_label__NPVtu","custom-control":"AttachmentFileInput_custom-control__5GUS_","custom-control-label":"AttachmentFileInput_custom-control-label___9wRR","custom-control-label--empty":"AttachmentFileInput_custom-control-label--empty__G6orV","custom-control-input":"AttachmentFileInput_custom-control-input__MOyO1","file-input":"AttachmentFileInput_file-input__cLBbA","has-error":"AttachmentFileInput_has-error__uFYgV","file-input__caption":"AttachmentFileInput_file-input__caption__lmnCN","file-input__upload-button":"AttachmentFileInput_file-input__upload-button__Emjq7","file-input__separator":"AttachmentFileInput_file-input__separator__FD3ZJ","file-input__image-container":"AttachmentFileInput_file-input__image-container__ggCY3","file-input__image-preview":"AttachmentFileInput_file-input__image-preview__knb6o","file-input__image":"AttachmentFileInput_file-input__image__gLWOu","file-input__image-alt":"AttachmentFileInput_file-input__image-alt__xDZaB","file-input__label-with-tooltip":"AttachmentFileInput_file-input__label-with-tooltip__ihqbk","file-input__tooltip":"AttachmentFileInput_file-input__tooltip__ZCrbQ","file-input__tooltip-icon":"AttachmentFileInput_file-input__tooltip-icon__rGHZ_","file-input__upload-spinner":"AttachmentFileInput_file-input__upload-spinner__14UTq","file-input__upload-text":"AttachmentFileInput_file-input__upload-text__2YEbG","close-button":"AttachmentFileInput_close-button__MXnMG","remove-image-button":"AttachmentFileInput_remove-image-button__XdVyn","toga-icon-x-dismiss":"AttachmentFileInput_toga-icon-x-dismiss__Y7DVH","file-container":"AttachmentFileInput_file-container__Wftva","file-container__name":"AttachmentFileInput_file-container__name__Ldgu4","caption":"AttachmentFileInput_caption__2k0fh","remove-file-button":"AttachmentFileInput_remove-file-button__1i0bT","x-dismiss":"AttachmentFileInput_x-dismiss__vlPRv"};

/***/ }),

/***/ 19329:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"AttachmentVideoInput_sr-only--mobile__2z8xs","sr-only":"AttachmentVideoInput_sr-only___dE8L","error-message":"AttachmentVideoInput_error-message__KbQMD","form-inline-edit":"AttachmentVideoInput_form-inline-edit__7UcRN","form-group":"AttachmentVideoInput_form-group__rAq_t","form-row":"AttachmentVideoInput_form-row__2Kiti","form-inline":"AttachmentVideoInput_form-inline__capp3","error":"AttachmentVideoInput_error__97YMP","input-group-append":"AttachmentVideoInput_input-group-append__zEaKF","input-group-currency":"AttachmentVideoInput_input-group-currency__reW_k","form-control":"AttachmentVideoInput_form-control__LkLkD","custom-select":"AttachmentVideoInput_custom-select__aTlNI","is-invalid":"AttachmentVideoInput_is-invalid__IgIFB","is-valid":"AttachmentVideoInput_is-valid__jzMPt","input-group":"AttachmentVideoInput_input-group__Ce40L","input-group-text":"AttachmentVideoInput_input-group-text__hq1yo","input-group-prepend":"AttachmentVideoInput_input-group-prepend__tj5pM","valid-feedback":"AttachmentVideoInput_valid-feedback__WSBOs","invalid-feedback":"AttachmentVideoInput_invalid-feedback__FHYm1","form-text":"AttachmentVideoInput_form-text__dOoBN","label":"AttachmentVideoInput_label__9myRK","custom-control":"AttachmentVideoInput_custom-control____rP8","custom-control-label":"AttachmentVideoInput_custom-control-label__Q14St","custom-control-label--empty":"AttachmentVideoInput_custom-control-label--empty__hbvyw","custom-control-input":"AttachmentVideoInput_custom-control-input__ulC7P","input--failure":"AttachmentVideoInput_input--failure__4OjAF","video-attachment__wrapper":"AttachmentVideoInput_video-attachment__wrapper__ufQaT","video-attachment__input":"AttachmentVideoInput_video-attachment__input__uLV8s","video-attachment__action-buttons":"AttachmentVideoInput_video-attachment__action-buttons__dvhzp","video-attachment__preview-container":"AttachmentVideoInput_video-attachment__preview-container__GuAD1","close-button":"AttachmentVideoInput_close-button__g5qVD","remove-video-button":"AttachmentVideoInput_remove-video-button__rWcu1","x-dismiss":"AttachmentVideoInput_x-dismiss__VITmq"};

/***/ }),

/***/ 93112:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loom-preview":"LoomPreview_loom-preview__6EmE6","loom-preview__iframe":"LoomPreview_loom-preview__iframe__KLBKE"};

/***/ }),

/***/ 81910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"EmojiPicker_sr-only--mobile__RbThE","sr-only":"EmojiPicker_sr-only__OgkdJ","error-message":"EmojiPicker_error-message__jo6of","form-inline-edit":"EmojiPicker_form-inline-edit__pVOjT","form-group":"EmojiPicker_form-group__0rZd5","form-row":"EmojiPicker_form-row__m5u7Y","form-inline":"EmojiPicker_form-inline__gMvLQ","error":"EmojiPicker_error__vp9l9","input-group-append":"EmojiPicker_input-group-append__rHjV4","input-group-currency":"EmojiPicker_input-group-currency__qFCUA","form-control":"EmojiPicker_form-control__wLLBt","custom-select":"EmojiPicker_custom-select__1lTyA","is-invalid":"EmojiPicker_is-invalid__F3Pe_","is-valid":"EmojiPicker_is-valid__DXyjM","input-group":"EmojiPicker_input-group__PK4m4","input-group-text":"EmojiPicker_input-group-text__B4eGF","input-group-prepend":"EmojiPicker_input-group-prepend__Sxysw","valid-feedback":"EmojiPicker_valid-feedback__xvoQH","invalid-feedback":"EmojiPicker_invalid-feedback__gYw5W","form-text":"EmojiPicker_form-text__RBS0l","label":"EmojiPicker_label__ZxEhs","custom-control":"EmojiPicker_custom-control__Ok_YS","custom-control-label":"EmojiPicker_custom-control-label__d8kML","custom-control-label--empty":"EmojiPicker_custom-control-label--empty__wHenp","custom-control-input":"EmojiPicker_custom-control-input__l2phw","emoji-picker":"EmojiPicker_emoji-picker__HTiO_","emoji-picker__button":"EmojiPicker_emoji-picker__button__4JGg9","emoji-picker__overlay":"EmojiPicker_emoji-picker__overlay__fCCSz","emoji-picker__emoji-mart":"EmojiPicker_emoji-picker__emoji-mart__PmFry","emoji-picker__emoji-mart--left":"EmojiPicker_emoji-picker__emoji-mart--left__r_Gjr","emoji-picker__emoji-mart--right":"EmojiPicker_emoji-picker__emoji-mart--right__Ybt03"};

/***/ }),

/***/ 46666:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"ExpandableTextArea_sr-only--mobile__RD9AK","sr-only":"ExpandableTextArea_sr-only__QT6b7","error-message":"ExpandableTextArea_error-message__dRAPL","form-inline-edit":"ExpandableTextArea_form-inline-edit__RYmTz","form-group":"ExpandableTextArea_form-group__AWsV_","form-row":"ExpandableTextArea_form-row__hbWjp","form-inline":"ExpandableTextArea_form-inline__JdVU1","error":"ExpandableTextArea_error__T6shW","input-group-append":"ExpandableTextArea_input-group-append__MIZCj","input-group-currency":"ExpandableTextArea_input-group-currency__2klPF","form-control":"ExpandableTextArea_form-control__4lNQP","custom-select":"ExpandableTextArea_custom-select__nrbVx","is-invalid":"ExpandableTextArea_is-invalid__tNOwC","is-valid":"ExpandableTextArea_is-valid__KkVxL","input-group":"ExpandableTextArea_input-group___Udif","input-group-text":"ExpandableTextArea_input-group-text__Gn4CN","input-group-prepend":"ExpandableTextArea_input-group-prepend__7o4Wi","valid-feedback":"ExpandableTextArea_valid-feedback__zCUZJ","invalid-feedback":"ExpandableTextArea_invalid-feedback__DU3B1","form-text":"ExpandableTextArea_form-text__dAkap","label":"ExpandableTextArea_label__qt_g7","custom-control":"ExpandableTextArea_custom-control__TOB_F","custom-control-label":"ExpandableTextArea_custom-control-label__9po6g","custom-control-label--empty":"ExpandableTextArea_custom-control-label--empty__x4_9u","custom-control-input":"ExpandableTextArea_custom-control-input__e78o_","expandable-text__label":"ExpandableTextArea_expandable-text__label__xxC2O","expandable-text__container":"ExpandableTextArea_expandable-text__container__NHFnT","actions__wrapper":"ExpandableTextArea_actions__wrapper__e3LzY","actions__cancel":"ExpandableTextArea_actions__cancel__W9ayv","actions__wrapper__left-container":"ExpandableTextArea_actions__wrapper__left-container__o_zJS","expandable-text__container--expanded":"ExpandableTextArea_expandable-text__container--expanded__fmIao","expandable-text__element":"ExpandableTextArea_expandable-text__element__Gx_7u","expandable-text__element-wrapper":"ExpandableTextArea_expandable-text__element-wrapper__Hu1Ns","full-width":"ExpandableTextArea_full-width__9ucoE","mentions-enabled-post-detail":"ExpandableTextArea_mentions-enabled-post-detail__GVNYE"};

/***/ }),

/***/ 6950:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"ReactionButton_sr-only--mobile__VItEx","sr-only":"ReactionButton_sr-only__jvmuK","error-message":"ReactionButton_error-message__iI7Q1","form-inline-edit":"ReactionButton_form-inline-edit__P_b58","form-group":"ReactionButton_form-group__9g559","form-row":"ReactionButton_form-row__In8K2","form-inline":"ReactionButton_form-inline__vCxmW","error":"ReactionButton_error__nHyXi","input-group-append":"ReactionButton_input-group-append__L1pqf","input-group-currency":"ReactionButton_input-group-currency__sMwl7","form-control":"ReactionButton_form-control__tw_AQ","custom-select":"ReactionButton_custom-select__yYmO6","is-invalid":"ReactionButton_is-invalid__agZCa","is-valid":"ReactionButton_is-valid__hNRX_","input-group":"ReactionButton_input-group__v8pVl","input-group-text":"ReactionButton_input-group-text__wfauN","input-group-prepend":"ReactionButton_input-group-prepend__NK16e","valid-feedback":"ReactionButton_valid-feedback__k5ETb","invalid-feedback":"ReactionButton_invalid-feedback__9XLh9","form-text":"ReactionButton_form-text__KJVgG","label":"ReactionButton_label__72fTj","custom-control":"ReactionButton_custom-control__ifciW","custom-control-label":"ReactionButton_custom-control-label__atY2F","custom-control-label--empty":"ReactionButton_custom-control-label--empty__IQy9n","custom-control-input":"ReactionButton_custom-control-input__lP5QJ","comment__reaction-button":"ReactionButton_comment__reaction-button__C37Lw"};

/***/ }),

/***/ 69095:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Input_sr-only--mobile__OSEAv","sr-only":"Input_sr-only__cJrfx","error-message":"Input_error-message__7094g","form-inline-edit":"Input_form-inline-edit__H7hT_","form-group":"Input_form-group___Kuer","form-row":"Input_form-row__geVcJ","form-inline":"Input_form-inline__VhXu0","error":"Input_error__uqIG6","input-group-append":"Input_input-group-append__2Euvb","input-group-currency":"Input_input-group-currency__nFMOR","form-control":"Input_form-control__55FeS","custom-select":"Input_custom-select__keA20","is-invalid":"Input_is-invalid__KLJ78","is-valid":"Input_is-valid__txrnc","input-group":"Input_input-group__Q_y0Y","input-group-text":"Input_input-group-text___0yM8","input-group-prepend":"Input_input-group-prepend__iuFtZ","valid-feedback":"Input_valid-feedback__I9mWP","invalid-feedback":"Input_invalid-feedback__55Feb","form-text":"Input_form-text__v0gkY","label":"Input_label__OWC07","custom-control":"Input_custom-control__2iqIr","custom-control-label":"Input_custom-control-label__Z0TBb","custom-control-label--empty":"Input_custom-control-label--empty__UEJSU","custom-control-input":"Input_custom-control-input__1DeVL","input__box":"Input_input__box__EvMKz","input__label":"Input_input__label__P0cOx","label-spacing":"Input_label-spacing__R2TE_","input__box--input":"Input_input__box--input__oFVjZ","input--extra-small":"Input_input--extra-small__JzwSr","input--small":"Input_input--small__qYlKv","input--medium":"Input_input--medium__oC_yl","input--large":"Input_input--large__gIGHF","input--extra-large":"Input_input--extra-large__HtZ_L","input__box-validation-message":"Input_input__box-validation-message__O6G_z","input__box-validation-message--error":"Input_input__box-validation-message--error__UdKgh","input__box-validation-message--success":"Input_input__box-validation-message--success__NIx_N","show":"Input_show__fF4Ms"};

/***/ }),

/***/ 82645:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Label_sr-only--mobile__hfvEM","sr-only":"Label_sr-only__BFbYY","error-message":"Label_error-message__a1trK","form-inline-edit":"Label_form-inline-edit__dLVwU","form-group":"Label_form-group__zW6rm","form-row":"Label_form-row__IKqFy","form-inline":"Label_form-inline__FOLzr","error":"Label_error__jmIe8","input-group-append":"Label_input-group-append__tktj5","input-group-currency":"Label_input-group-currency__nK_nJ","form-control":"Label_form-control__scbLG","custom-select":"Label_custom-select__C_jQO","is-invalid":"Label_is-invalid__cxk8Q","is-valid":"Label_is-valid__sfsi2","input-group":"Label_input-group__G2Gl2","input-group-text":"Label_input-group-text__HJT5l","input-group-prepend":"Label_input-group-prepend__1cRx5","valid-feedback":"Label_valid-feedback__Owzed","invalid-feedback":"Label_invalid-feedback__sH_9E","form-text":"Label_form-text__k9zcM","label":"Label_label__l3XB9","custom-control":"Label_custom-control__z_QNp","custom-control-label":"Label_custom-control-label__RBeMO","custom-control-label--empty":"Label_custom-control-label--empty__rUZm7","custom-control-input":"Label_custom-control-input__cLRbk"};

/***/ })

}]);